import React, {  use, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuBar from './common/MenuBar';
import '../assets/css/home.css';
import { loadRxDetails, unlockRXDetails, cancelEntireOrder,
  getPremierAccumulatorModels, loadRxCostPharmacy, loadRebateValidationFlag, savePrescription, 
  loadRXCostshareDetails,  saveCostShareRebateData, saveRXCostshareDetails, loadAccumulator, fetchAvailityMemberCoverage
, getAttachmentPath, trackFedexShipment, loadMemberConcern, getWinCardUrl, getOpenOrdersFile} from '../Services/loadOrder';
import OrderSummary from './common/OrderSummary'; 
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight, ConciergeBellIcon } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import{editOrderDetails} from '../Services/loadOrder';
import TrackingModal from './common/TrackingModal';
import BackWindowModal from './common/BackWindowModal';
import CancelOrderModal from './common/CancelOrderModal';
import ThankYouModal from './common/ThankYouModal';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const OpenOrders = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { taskId, contract, pharmacyId, userId, pharmCode } = state || {};
  const [rxData, setRxData] = useState(null);
  const [error, setError] = useState(null);
  const [gridRows, setGridRows] = useState([]);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [showSummary, setShowSummary] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [trackingResult, setTrackingResult] = useState(null);
  const [shippingCarrier, setShippingCarrier] = useState('');
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [accumAccess, setAccumAccess] = useState(null);
  const [rebateValidationFlag, setRebateValidationFlag] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isBackWindowOpen, setIsBackWindowOpen] = useState(false);
  const [isCancelOrderOpen, setIsCancelOrderOpen] = useState('');
  const [cancelReason, setCancelReason] = useState('');
  const [costPharmacyData, setCostPharmacyData] = useState(null);
  const [Rx_Cost_Before_CostShare, setRx_Cost_Before_CostShare] = useState(null);
  const [Pharmacy_Reimb_Amt_Before_CostShare, setPharmacy_Reimb_Amt_Before_CostShare] = useState(0);
  const [pharmReimbWithoutRebate, setPharmReimbWithoutReabtae] = useState(0);
  const [pharmReimbwithRebate, setPharmReimbwithRebate] = useState(0);
  const [singleRowofferAmount, setSingleRowOfferAmount] = useState(0);
  const [totalMemberPays, setTotalMemberPays] = useState('0.00');
  const [totalCopay, setTotalCopay] = useState('0.00');
  const [totalMenopurCostShare, setTotalMenopurCostShare] = useState('0.00');
  const [totalWinPays, setTotalWinPays] = useState('0.00');
  const [chewyRows, setChewyRows] = useState([]);
  const [chewyFertilityRows, setChewyFertilityRows] = useState([]);
  const [notes, setNotes] = useState('');
  const [showThankYou, setShowThankYou] = useState(false);
  // Add state for attachment URLs
const [attachmentUrls, setAttachmentUrls] = useState([]);
const [notesBoxActive, setNotesBoxActive] = useState(false);
const [shippingNotes, setShippingNotes] = useState('');
const [actualDeliveryDate, setActualDeliveryDate] = useState('');
const [latestStatus, setLatestStatus] = useState(''); 
const [errorTrackingStatus, setErrorTrackingStatus] = useState('');

// menopur global variables

const [memberConcernFlag, setMemberConcernFlag] = useState(false);
const [showMemberWinCard, setShowMemberWinCard] = useState(false);
const [requestId, setRequestId] = useState('');
const [menopurGridRows, setMenopurGridRows] = useState([]);
const [mainGridRows, setMainGridRows] = useState([]);
const [planType, setPlanType] = useState('');
// const [menopurCopayAmount, setMenopurCopayAmount] = useState(0);
// const [mainCopayAmount, setMainCopayAmount] = useState(0);
const [winCardAmount, setWinCardAmount] = useState(0.00);
const [firstName, setFirstNAme] = useState('');
const [lastName, setLastName] = useState('');
//contract === "SchoolCare" || contract === "Gartner-Cigna" || contract === "Smith & Nephew"
const cignaContract = ["SchoolCare", "Gartner-Cigna", "Smith & Nephew", "CIGNA"];
const [medicalAuth, setMedicalAuth] = useState('');
const [cignaRXAuth, setCignaRXAuth] = useState('');
const [readyForInitialCalc, setReadyForInitialCalc] = useState(false); // ADD THIS


  useEffect(() => {
  const handlePopState = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.userId && user?.pharmacyId) {
      // Cancel the back by immediately returning to the forward entry
      window.history.go(1); // same as history.forward()

      // Keep the current URL as the active entry *without* adding to history
      // (also handy to stash a flag in state if you want)
      window.history.replaceState(
        { blockBack: true, ts: Date.now() },
        '',
        window.location.href
      );
    }
  };

  // 1) Tag the current entry (no new entry created)
  window.history.replaceState(
    { blockBack: true, ts: Date.now() },
    '',
    window.location.href
  );

  // 2) Seed ONE forward entry so the first Back can be neutralized with go(1)
  window.history.pushState({ anchor: true }, '', window.location.href);

  window.addEventListener('popstate', handlePopState);
  return () => window.removeEventListener('popstate', handlePopState);
}, []);




  useEffect(() => {
  const fetchRxDetails = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    
    if (!user || !taskId || !contract) return;

    try {
      const response = await loadRxDetails(taskId, contract, pharmacyId, userId);
      console.log("Response from loadRxDetails:", response);

      if (!response.success) {
        setError(response.message);
        navigate('/error-page');
        return;
      }

      const { TaskDetail, DrugInfos, Prescriptions, ShippingInfos, Documents } = response.data;

      const details = {
        ...TaskDetail,
        DrugInfos,
        Prescriptions,
        ShippingInfos,
        Documents,
      };

      setNotes(TaskDetail?.Notes || TaskDetail[0]?.Notes);
      setShippingNotes(ShippingInfos?.[0]?.Notes || '');
      
      console.log("Notes:>>>>>>>>>>>", TaskDetail?.Notes || TaskDetail[0]?.Notes); 
      const memberName = details[0]?.MemberName || '';
      console.log("Member Name:", memberName);
      const firstName = memberName.split(',')[1] || '';
      const lastName = memberName.split(',')[0] || '';
      setFirstNAme(firstName);
      setLastName(lastName);
      

      const contractType = details[0]?.ContractType;

      const planType = details[0]?.PlanName || '';

      setPlanType(planType);  
      
      let MemberConcern = false;

      if (contractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx") {
        MemberConcern = await loadMemberConcern(taskId, contract);
        console.log("Member Concern:", MemberConcern.data);

        if (MemberConcern?.data?.Flag === 'Y') {
          setMemberConcernFlag(true);
        } 
        if (MemberConcern?.data?.MemberConsent === 'Y') {
          setShowMemberWinCard(true);
        }
        setRequestId(MemberConcern?.data?.RequestId);
        console.log("Request ID^^^^^^^^^^^^^^^^^:", MemberConcern?.data?.RequestId);
      }

      // Fetch attachment URLs
      const fetchUrls = async () => {
        const urls = await Promise.all(
          (Documents || []).map(doc => getAttachmentPath(doc.Path))
        );
        console.log("Fetched attachment URLs:", urls);
        setAttachmentUrls(urls);
      };
      fetchUrls();

      setRxData(details);
      setShippingCarrier(ShippingInfos?.[0]?.ShippingCarrier || '');

      // ✅ Deduplication helper
      const removeDuplicatePrescriptions = (prescriptions) => {
        const seen = new Set();
        return prescriptions.filter(pres => {
          const key = `${pres.PresID}-${pres.NDC}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      };

      // ✅ Apply deduplication
      const uniquePrescriptions = removeDuplicatePrescriptions(Prescriptions || []);

      // --- PREMIER & ACCUMULATOR LOGIC ---

      if ( contract === "Moelis-Cigna-Premier Rx" || contractType === 'Premier') { 

       if ((contractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx" ) && MemberConcern.data.Flag === 'Y') {
        const result = await getPremierAccumulatorModels(contract);

        if (result?.AccumAccess === 'Y') {
          setAccumAccess('Y');  
        

        const rebateFlag = await loadRebateValidationFlag( contract,
          details[0]?.MemberID, pharmacyId, userId );
        setRebateValidationFlag(rebateFlag?.Validation === 'Y' ? 'Y' : 'N');

        // Use details.Prescriptions for initial grid setup
  const prescriptions = details?.Prescriptions || [];
  const contractType = details[0]?.ContractType;
  const pharmacyID = details[0]?.PharmacyID || pharmacyId;

  console.log("Contract Type:", contractType);

  // Split prescriptions into Menopur and others
  const menopurRows = prescriptions.filter(p => p.DrugName?.toUpperCase().includes('MENOPUR'));
  const otherRows = prescriptions.filter(p => !p.DrugName?.toUpperCase().includes('MENOPUR'));

  console.log("Menopur Rows:", menopurRows);
  console.log("Other Rows:", otherRows);

  setMenopurGridRows(menopurRows.map(pres => ({
    ...pres,
    id: pres.PresID,
    CancelQty: parseFloat(pres.AppQty || 0) - parseFloat(pres.DispQty || 0)
  })));

  setMainGridRows(otherRows.map(pres => ({
    ...pres,
    id: pres.PresID,
    CancelQty: parseFloat(pres.AppQty || 0) - parseFloat(pres.DispQty || 0)
  })));

  // after setMenopurGridRows(...) and setMainGridRows(...)
setGridRows([
  ...menopurRows.map(pres => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
  ...otherRows.map(pres   => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
]);
}
setReadyForInitialCalc(true);
return; // keep your early return


  // Return early so the rest of the logic does not run for this case
  

       } else if (
        ((contractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx") && MemberConcern.data.Flag !== 'Y')
      ) {
        const result = await getPremierAccumulatorModels(contract);

        if (result?.AccumAccess === 'Y') {
          setAccumAccess('Y');

          const updatedPrescriptions = uniquePrescriptions.map(pres => {
            const dispQty = parseFloat(pres.DispQty || 0);
            const appQty = parseFloat(pres.AppQty || 0);

            return {
              ...pres,
              id: pres.PresID,
              // CancelQty: dispQty ? appQty - dispQty : '',
              // ['Cancel Qty']: dispQty ? appQty - dispQty : '',
            };
          });

          setGridRows(updatedPrescriptions);

          // Rebate Validation Flag
          const rebateFlag = await loadRebateValidationFlag(
            contract,
            rxData?.MemberID ||
              rxData?.TaskDetail?.MemberID ||
              rxData?.TaskDetail[0]?.MemberID,
            pharmacyId,
            userId
          );
          setRebateValidationFlag(rebateFlag?.Validation === 'Y' ? 'Y' : 'N');
        } else {
          setAccumAccess('N');

          const updatedPrescriptions = uniquePrescriptions.map(pres => {
            const dispQty = parseFloat(pres.DispQty || 0);
            const appQty = parseFloat(pres.AppQty || 0);

            return {
              ...pres,
              id: pres.PresID,
              // CancelQty: dispQty ? appQty - dispQty : '',
              // ['Cancel Qty']: dispQty ? appQty - dispQty : '',
            };
          });

          setGridRows(updatedPrescriptions);
        }
      }} else {
        // --- NON-PREMIER LOGIC ---
        const updatedPrescriptions = uniquePrescriptions.map(pres => ({
          ...pres,
          id: pres.PresID,
          // CancelQty: parseFloat(pres.AppQty || 0) - parseFloat(pres.DispQty || 0),
        }));

        setGridRows(updatedPrescriptions);

        // Calculate total for non-premier
        const newTotal = updatedPrescriptions
          .reduce((sum, row) => sum + parseFloat(row.Amount || 0), 0)
          .toFixed(2);
        setTotalAmount(newTotal);
        setTotalWinPays(newTotal);
      }
    } catch (err) {
      console.error("Error in fetchRxDetails:", err);
      toast.error("Failed to load prescription details");
      navigate('/error-page');
    }
    setReadyForInitialCalc(true); // Set this to true after data is loaded and processed
  };

  fetchRxDetails();
}, [taskId, contract, pharmacyId, userId]);



useEffect(() => {
    if (!rxData) return;

    const prescriptions = rxData?.Prescriptions || [];

    // For DTC/RX contracts, just map as-is
  if (contract === 'WINFertility DTC' || contract === 'WINFertilityRx') {
    setGridRows(prescriptions.map(pres => ({
      ...pres,
      id: pres.PresID,
      CancelQty: pres?.['Cancel Qty'],
      DispQty: pres?.['Disp Qty'],
      ['Reimbursment Amount']: pres?.['Reimbursment Amount'],
    })));
    // Optionally, set totalAmount
    const total = prescriptions.reduce((sum, r) => sum + (parseFloat(r?.['Reimbursment Amount']) || 0), 0).toFixed(2);
    console.log("Total Amount for DTC/RX:", total);
    setTotalAmount(total);
    setTotalWinPays(total);
    return;
  }


    const drugInfos = rxData?.DrugInfos || [];

    const highestPRPByNDC = drugInfos.reduce((map, drug) => {
      const existing = map.get(drug.NDC);
      const currentPRP = parseFloat(drug.PRP || 0);
      const existingPRP = existing ? parseFloat(existing.PRP || 0) : -1;
    
      if (!existing || currentPRP > existingPRP) {
        map.set(drug.NDC, drug);
      }
    
      return map;
    }, new Map());
    
    const uniqueDrugInfos = Array.from(highestPRPByNDC.values());
    
    
    const generatedRows = prescriptions.map((prescription) => {
      const matchingDrugs = drugInfos.filter(d => d.NDC === prescription.NDC);
      const highestPRPDrug = matchingDrugs.reduce((prev, curr) =>
        parseFloat(curr.PRP) > parseFloat(prev.PRP) ? curr : prev,
        { PRP: 0 }
      );
    
      const appQty = parseFloat(prescription.AppQty ?? 0);
      const dispQty = parseFloat(prescription.DispQty ?? 0);
      const prp = parseFloat(highestPRPDrug.PRP || 0);
      const cancelQty = dispQty ? appQty - dispQty : '';
      const amount = dispQty ? (dispQty * prp).toFixed(2) : '';
      console.log(` DispQty=${dispQty}, CancelQty=${cancelQty}, Amount=${amount}, EFFdt=${highestPRPDrug[0]?.MedStartDate}`);
      console.log("This is the medstartdate", prescriptions.MedStartDate);
    
      return {
        id: prescription.PresID, 
        ...prescription,
        PRP: prp,
        DrugName: highestPRPDrug.DrugName || prescription.DrugName,
        GPIName: highestPRPDrug.GPIName || prescription.GPIName,
        Effdt: prescriptions.MedStartDate,
        CancelQty: cancelQty,
        Amount: amount
      };
    });
    
    
  //   const totalAmount = generatedRows.reduce((sum, row) => {
  //     return sum + parseFloat(row.Amount || 0);
  //   }, 0).toFixed(2);
    
  //   setGridRows(generatedRows);
  //   setTotalAmount(totalAmount); 
    

  }, [rxData]);


  //useEffect for making  the initial value load with the appqty

  // ...existing code...

  //useEffect for making the initial value load with the appqty

  useEffect(() => {
    if (!readyForInitialCalc) return; // ✅ Wait for fetchRxDetails to finish

    const initialValue = async () => {
      

      const contractType = rxData[0]?.ContractType?.trim();
      const isPremier = contractType === 'Premier' || contract === 'Moelis-Cigna-Premier Rx';
      if (!isPremier) return; // Only run this logic for Premier contracts

      // if (menopurGridRows.length === 0) {
      console.log("running this useeffect for initial values with appqty");

      const isKimco = (contract?.trim() === 'Kimco Realty-Anthem-Premier');
      const isChewy = (contract?.trim() === 'Chewy-Aetna-Premier');
      const isPPO = planType.toUpperCase().includes('PPO');
      let memberPaysTotal = 0;
      let winPaysTotal = 0;
      let copayTotal = 0;
      let displayValueRembAmountTotal = 0;
      let valueRembAmountTotal = 0;

      for (let i = 0; i < gridRows.length; i++) {
        const appQty = parseFloat(gridRows[i].AppQty || 0);
        if (appQty <= 0) continue;

        const objectForcostPharmacy = await loadRxCostPharmacy(contract, pharmCode.toString(), buildRxItemsXmlFromAppQty(gridRows[i]));
        const displayValueRembAmount = objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
        const valueRembAmount = rebateValidationFlag === 'Y'
          ? objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0
          : objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
        displayValueRembAmountTotal += displayValueRembAmount;
        valueRembAmountTotal += valueRembAmount;
        copayTotal = valueRembAmountTotal;

        if (!isKimco && !isChewy) {
          memberPaysTotal = await calculateCostShareDetails(copayTotal);
        } else if (isKimco) {
          memberPaysTotal = Math.min(40, copayTotal);
        } else if (isChewy && isPPO) {
          memberPaysTotal = Math.min(50, copayTotal);
        } else if (isChewy && !isPPO) {
          memberPaysTotal = 0;
        }

        winPaysTotal = displayValueRembAmountTotal - parseFloat(memberPaysTotal || 0);
      }

      setTotalMemberPays(parseFloat(memberPaysTotal || 0).toFixed(2));
      setTotalWinPays(parseFloat(winPaysTotal || 0).toFixed(2));
    // } 
//     else if (menopurGridRows.length > 0) {
//       console.log("running this useeffect for menopurcase");

//       const isKimco = (contract?.trim() === 'Kimco Realty-Anthem-Premier');
//       const isChewy = (contract?.trim() === 'Chewy-Aetna-Premier');
//       const isPPO = planType.toUpperCase().includes('PPO');
//       let memberPaysTotal = 0;
//       let menopurCopayTotal = 0;
//       let menopurWinPaysTotal = 0;
//       let winPaysTotal = 0;
//       let copayTotal = 0;
//       let displayValueRembAmountTotal = 0;
//       let menopurDisplayValueRembAmountTotal = 0;
//       let valueRembAmountTotal = 0;
//       let menopurValueRembAmountTotal = 0;

//       for (let i = 0; i < mainGridRows.length; i++) {
//         const appQty = parseFloat(mainGridRows[i].AppQty || 0);
//         if (appQty <= 0) continue;

//         const objectForcostPharmacy = await loadRxCostPharmacy(contract, pharmCode.toString(), buildRxItemsXmlFromAppQty(gridRows[i]));
//         const displayValueRembAmount = objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
//         const valueRembAmount = rebateValidationFlag === 'Y'
//           ? objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0
//           : objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
//         displayValueRembAmountTotal += displayValueRembAmount;
//         valueRembAmountTotal += valueRembAmount;
//         copayTotal = valueRembAmountTotal;

//         if (!isKimco && !isChewy) {
//           memberPaysTotal = await calculateCostShareDetails(copayTotal);
//         } else if (isKimco) {
//           memberPaysTotal = Math.min(40, copayTotal);
//         } else if (isChewy && isPPO) {
//           memberPaysTotal = Math.min(50, copayTotal);
//         } else if (isChewy && !isPPO) {
//           memberPaysTotal = 0;
//         }

//         winPaysTotal = displayValueRembAmountTotal - parseFloat(memberPaysTotal || 0);
//       }
//       for (let i = 0; i < menopurGridRows.length; i++) {
//         const appQty = parseFloat(menopurGridRows[i].AppQty || 0);
//         if (appQty <= 0) continue;

//         const objectForcostPharmacy = await loadRxCostPharmacy(contract, pharmCode.toString(), buildRxItemsXmlFromAppQty(gridRows[i]));
//         const displayValueRembAmount = objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
//         const valueRembAmount = rebateValidationFlag === 'Y'
//           ? objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0
//           : objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
//         menopurDisplayValueRembAmountTotal += displayValueRembAmount;
//         menopurValueRembAmountTotal += valueRembAmount;
//         copayTotal = valueRembAmountTotal;

//         if (!isKimco && !isChewy) {
//           menopurCopayTotal = await calculateCostShareDetails(copayTotal);
//         } else if (isKimco) {
//           menopurCopayTotal = Math.min(40, copayTotal);
//         } else if (isChewy && isPPO) {
//           menopurCopayTotal = Math.min(50, copayTotal);
//         } else if (isChewy && !isPPO) {
//           menopurCopayTotal = 0;
//         }

//         // winPaysTotal = displayValueRembAmountTotal - parseFloat(memberPaysTotal || 0);
//       }
//       const rxCost = displayValueRembAmountTotal + menopurDisplayValueRembAmountTotal;
//       winPaysTotal = (Number(rxCost) - Number(menopurDisplayValueRembAmountTotal) - Number(memberPaysTotal + menopurCopayTotal)) + Number(menopurCopayTotal);
//       const totalCostShare = Number(memberPaysTotal) + Number(menopurCopayTotal);
//       const winCardAmount = (Number(menopurDisplayValueRembAmountTotal) - Number(menopurCopayTotal)).toFixed(2);
// //       const winPays = (Number(rxCost) - Number(menopurTotal) - Number(totalCostShare)) + Number(menopurCostShare);
// // const winCardValueRaw = Number(menopurTotal) - Number(menopurCostShare);



//       setTotalMemberPays(parseFloat(totalCostShare || 0).toFixed(2));
//       setTotalWinPays(parseFloat(winPaysTotal || 0).toFixed(2));
//       setWinCardAmount(parseFloat(winCardAmount).toFixed(2));
//     }
      
  } 

    initialValue();
  }, [readyForInitialCalc]);

// ...existing code...

// useEffect(() => {
//   if (!readyForInitialCalc) return;
//   const calculateHmoi = async () => {
//     if (contract !== 'HMO Illinois') return;
//     console.log("running this useeffect for HMO Illinois when total amount is 0");
//     let winPaysTotal = 0;
// for (let i = 0; i < gridRows.length; i++) {
//   const appQty = parseFloat(gridRows[i].AppQty || 0);
//   const prp = parseFloat(gridRows[i]?.["Unit Price"] || 0);
//   if (appQty <= 0) continue;

//   console.log(`Before Row ${i}: current total = ${winPaysTotal.toFixed(2)}`);
  
//   const contribution = appQty * prp;
//   winPaysTotal += contribution;

//   console.log(`Row ${i}: AppQty=${appQty}, Unit Price=${prp}, Contribution=${contribution.toFixed(2)}, New total=${winPaysTotal.toFixed(2)}`);
// }
// console.log("Final total win pays for HMO Illinois:", winPaysTotal.toFixed(2));
//       setTotalWinPays(winPaysTotal);
// setTotalAmount(parseFloat(winPaysTotal || 0).toFixed(2))
//   }
//   calculateHmoi();
// }, [readyForInitialCalc])



    const buildRxItemsXmlFromDispQty = (row) => {
  let xml = `<RxItems>`;
  
    if (row.NDC && row.DispQty > 0) {
      xml += `<Item NDC="${row.NDC}" AppQty="${row.DispQty}" />`; 
    }
  
  xml += `</RxItems>`;
  return xml;
};
    const buildRxItemsXmlFromAppQty = (row) => {
  let xml = `<RxItems>`;

    if (row.NDC && row.AppQty > 0) {
      xml += `<Item NDC="${row.NDC}" AppQty="${row.AppQty}" />`;
    }
  
  xml += `</RxItems>`;
  return xml;
};

useEffect(() => {
  if (!rxData) return;
  if (cignaRXAuth === '' && medicalAuth === '') return;

  if (cignaRXAuth !== '' || medicalAuth !== '') {
    rxData[0].PharmacyAuth = cignaRXAuth;
    rxData[0].VendorAuth = medicalAuth;
    console.log("Updated rxData with Auths:", rxData );  
  }


  
}, [cignaRXAuth, medicalAuth]);




//   const validateReasonsSelected = () => {
//     const missingReason = gridRows.some(row => !row.Reason || row.Reason.trim() === '');
//     if (missingReason) {
//       toast.error("Please select a reason for all rows.");
//       return false;
//     }
//     return true;
//   };

  const clearedRows = gridRows.map(row => ({
  ...row,
  Reason: '',
  DispQty: 0,
  CancelQty: 0,
  Amount: 0
}));

// for chewy contracts

useEffect(() => {
  if (contract !== 'Chewy-Aetna-Premier' || !rxData) return;

  const fetchChewyGridsData = async () => {
    let memberId = rxData[0]?.MemberID;
    let patientFirstName = rxData[0]?.MemberName;
    let patientLastName = rxData[1]?.MemberName;
    let patientBirthDate = rxData[0]?.DOB;
    let sourceSystem = "PBMS";
    let user = userId;
    console.log("Fetching Chewy grids data with:", {
      memberId, 
      patientFirstName,
      patientLastName,
      patientBirthDate,
      contract,
      sourceSystem,
      user
    });

    if (
      memberId?.toLowerCase().includes("test") &&
      patientFirstName?.toLowerCase().includes("test") &&
      patientLastName?.toLowerCase().includes("test")
    ) {
      memberId = "234651_10";
      patientFirstName = "Lea";
      patientLastName = "Spencer";
      patientBirthDate = "10/08/1987";
      sourceSystem = "PBMS Test";
      user = "SADV";
    }

    const availityData = await fetchAvailityMemberCoverage({
      memberId,
      patientFirstName,
      patientLastName,
      patientBirthDate,
      contract,
      sourceSystem,
      user
    });

    // ---- Parse availityData to extract accumulator values ----
    let deductibleTotal = "0.00";
    let deductibleRemaining = "0.00";
    let coinsurancePercent = "0";
    let copayAmount = "0.00";

    try {
      const plans = availityData?.plans;
      if (plans && Array.isArray(plans)) {
        // Find the first plan with benefits
        const benefits = plans[0]?.benefits;
        if (benefits && Array.isArray(benefits)) {
          // Deductibles
          const amounts = benefits[0]?.amounts;
          const deductibles = amounts?.deductibles?.inNetwork || [];
          // Prefer "Individual", else "Family"
          const indDed = deductibles.find(x => x?.level === "Individual");
          const famDed = deductibles.find(x => x?.level === "Family");
          if (indDed) {
            deductibleTotal = indDed?.total?.toString() ?? "0.00";
            deductibleRemaining = indDed?.remaining?.toString() ?? "0.00";
          } else if (famDed) {
            deductibleTotal = famDed?.total?.toString() ?? "0.00";
            deductibleRemaining = famDed?.remaining?.toString() ?? "0.00";
          }

          // Coinsurance and Copay (from Infertility benefit, usually index 1)
          let planName = availityData?.planName || ""; // You may need to get this from somewhere else
          let coinsurance = 0;
          let copay = 0;
          if (benefits.length > 1) {
            // Try to get from Infertility benefit
            const infertilityAmounts = benefits[1]?.amounts;
            // Coinsurance
            const coins = infertilityAmounts?.coInsurance?.inNetwork?.[0]?.amount;
            coinsurance = coins ? parseFloat(coins) * 100 : 0;
            // Copay
            const copayVal = infertilityAmounts?.coPayment?.inNetwork?.[0]?.amount;
            copay = copayVal ? parseFloat(copayVal) : 0;
          }
          // If not found, fallback to plan type
          if (!coinsurance && planName.includes("PPO")) {
            coinsurance = 20;
            copay = 50;
          } else if (!coinsurance) {
            coinsurance = 10;
            copay = 0;
          }
          coinsurancePercent = coinsurance.toString();
          copayAmount = copay.toFixed(2);
        }
      }
    } catch (err) {
      console.error("Error parsing availityData:", err);
      toast.error("Failed to parse member coverage data");
    }

    // ---- Build DataGrid rows ----
    setChewyRows([
      {
        id: 1,
        'Member Cost Share': 'Deductible Total',
        'In-Network': `$ ${deductibleTotal}`,
        'Out-of-Network': 'NA'
      },
      {
        id: 2,
        'Member Cost Share': 'Deductible Remaining',
        'In-Network': `$ ${deductibleRemaining}`,
        'Out-of-Network': 'NA'
      },
      {
        id: 3,
        'Member Cost Share': 'Coinsurance',
        'In-Network': `${coinsurancePercent} %`,
        'Out-of-Network': 'NA'
      },
      {
        id: 4,
        'Member Cost Share': 'Copay',
        'In-Network': `$ ${copayAmount}`,
        'Out-of-Network': 'NA'
      }
    ]);
  };

  fetchChewyGridsData();
}, [contract, rxData, userId]);

const chewyColumns = [
  { field: 'Member Cost Share', headerName: 'Member Cost Share', width: 200, headerClassName: 'pink-header' },
  { field: 'In-Network', headerName: 'In-Network', width: 150, headerClassName: 'pink-header' },
  { field: 'Out-of-Network', headerName: 'Out-of-Network', width: 150, headerClassName: 'pink-header' }
];


const chewyColumnsFertilityGrid = [
  { field: 'Fertility Accumulator', headerName: 'Fertility Accumulator', width: 200, headerClassName: 'pink-header' },
  { field: 'In-Network', headerName: 'In-Network', width: 150, headerClassName: 'pink-header' },
  { field: 'Out-of-Network', headerName: 'Out-of-Network', width: 150, headerClassName: 'pink-header' }
];

useEffect(() => {
  if (contract !== 'Chewy-Aetna-Premier' || !rxData) return;

  const fetchChewyAccumulator = async () => {
    try {
      const result = await loadAccumulator(rxData[0]?.MemberID, rxData[0]?.AuthNo, contract);
      console.log("Accumulator Payload:", {
        MemberID: rxData[0]?.MemberID,
        AuthNo: rxData[0]?.AuthNo,
        Contract: contract
      });
      console.log("Accumulator Data:", result);

      if (result.success && result.data) {
        setChewyFertilityRows([
          {
            id: 1,
            'Fertility Accumulator': 'Benefit Limit',
            'In-Network': `$ ${result.data.AllowedAccumulator ?? '0.00'}`,
            'Out-of-Network': 'NA'
          },
          {
            id: 2,
            'Fertility Accumulator': 'Remaining Balance',
            'In-Network': `$ ${result.data.RemainingAccumulator ?? '0.00'}`,
            'Out-of-Network': 'NA'
          }
        ]);
      } else {
        setChewyFertilityRows([]);
        toast.error(result.message || "No accumulator data found.");
      }
    } catch (error) {
      console.error("Error fetching accumulator data:", error);
      toast.error("Failed to fetch accumulator data");
      setChewyFertilityRows([]);
    }
  };

  fetchChewyAccumulator();
}, [contract, rxData]);



// Debounced tracking number validation
 useEffect(() => {
  if (!trackingNumber) {
    setTrackingResult(null);
    return;
  }
  if (shippingCarrier.toLowerCase() !== 'fedex') {
    // toast.error("Only FedEx tracking is supported.");
    return;
  }
  const handler = setTimeout(async () => {
    try {
      const response = await trackFedexShipment(trackingNumber);
      console.log("FedEx Tracking Response:$$$$$$$$>>>>>>>>", response);
      setTrackingResult(response);
      console.log ("this is the tracking result", response.data);
      const deliveryDate = response.data?.output?.completeTrackResults[0]?.
      trackResults[0]?.dateAndTimes?.find(
  item => item.type === "ACTUAL_DELIVERY"
)?.dateTime || "";

      const status = response.data?.output?.completeTrackResults[0]?.
      trackResults[0]?.latestStatusDetail?.statusByLocale;

      const errorStatus =  response.data?.output?.completeTrackResults[0]?.
      trackResults[0]?.error;

      if (errorStatus) {
        setErrorTrackingStatus(errorStatus);
        return;
      }

const onlyDate = deliveryDate.split("T")[0]; 
console.log(onlyDate);
      console.log("Latest Status and date",status, onlyDate);

      setActualDeliveryDate(onlyDate);
      setLatestStatus(status);
    } catch (error) {
      setTrackingResult(null);
      toast.error("Tracking failed. Please check the tracking number.");
    }
  }, 2000);

  return () => clearTimeout(handler);
}, [trackingNumber]);



//handle Disp Qty Change for Premier in case of member concern is Y

const handleDispQtyChangeMainGrid = async (value, rowId) => {
  const updatedMainRows = [...mainGridRows];
  const updatedGridRows = [...gridRows]; 
  const isKimco = (contract?.trim() === 'Kimco Realty-Anthem-Premier');
  const isChewy = (contract?.trim() === 'Chewy-Aetna-Premier');
   //const planName = (rxData?.[0]?.PlanName || '');
    const isPPO = planType.toUpperCase().includes('PPO'); 

  const rowMainIndex = updatedMainRows.findIndex(row => row.id === rowId);
  
  if (rowMainIndex === -1) return;

  const dispQty = parseFloat(value || 0);
  const appQty = parseFloat(updatedMainRows[rowMainIndex].AppQty || 1);

  if (dispQty > appQty) {
    toast.error('Dispensed quantity cannot be greater than Approved quantity');
    return;
  }

  updatedMainRows[rowMainIndex].DispQty = dispQty;
  updatedMainRows[rowMainIndex]['Disp Qty'] = dispQty;
  updatedMainRows[rowMainIndex].CancelQty = appQty - dispQty;
  updatedMainRows[rowMainIndex]['Cancel Qty'] = appQty - dispQty;

  const objectForcostPharmacy = await loadRxCostPharmacy(contract, pharmCode.toString(), buildRxItemsXmlFromDispQty(updatedMainRows[rowMainIndex]));
  console.log("Cost Pharmacy Request:", contract, pharmCode.toString(), buildRxItemsXmlFromDispQty(updatedMainRows[rowMainIndex]));
  setCostPharmacyData(objectForcostPharmacy);

  setRx_Cost_Before_CostShare(objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0);
  setPharmacy_Reimb_Amt_Before_CostShare(objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0);

  const displayValueRembAmount = objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
  const valueRembAmount = rebateValidationFlag === 'Y'
  ? objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0 : 
  objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;

  const prevMemberPays = parseFloat(totalMemberPays).toFixed(2);

   if (
    ( (rxData[0]?.ContractType?.trim() === 'Premier' || 
    contract === "Moelis-Cigna-Premier Rx") && accumAccess === 'Y') 
  ) {
   
    const rembAmount = valueRembAmount; 
    const rembAmountDisplay = displayValueRembAmount;


updatedMainRows[rowMainIndex].ReimbursementAmountDisplay = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // returns number
updatedMainRows[rowMainIndex].ReimbursementAmountValue = parseFloat(Number(rembAmount || 0).toFixed(2)); // returns number
updatedMainRows[rowMainIndex]['Reimbursment Amount'] = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // returns number
   


    let totalRembDisplayAmount = () => { 
      let value = 0;
      for (let i = 0; i < updatedMainRows.length; i++) {
        let currentRowValue = parseFloat(updatedMainRows[i].ReimbursementAmountDisplay || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }
    console.log("Total Reimbursement Display Amount:", totalRembDisplayAmount());


    
    let totalRembAmount = () => { 
      let value = 0;
      for (let i = 0; i < updatedMainRows.length; i++) {
        let currentRowValue = parseFloat(updatedMainRows[i].ReimbursementAmountValue || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }

    let totalMenopurRembDisplayAmount = () => { 
      let value = 0;
      for (let i = 0; i < menopurGridRows.length; i++) {
        let currentRowValue = parseFloat(menopurGridRows[i].ReimbursementAmountDisplay || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }
    console.log("Total Reimbursement Display Amount:", totalMenopurRembDisplayAmount());


    
    let totalMenopurRembAmount = () => { 
      let value = 0;
      for (let i = 0; i < menopurGridRows.length; i++) {
        let currentRowValue = parseFloat(menopurGridRows[i].ReimbursementAmountValue || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }

    // Use this total for your copay calculation
    let copayMain;

    if (rebateValidationFlag === 'Y') {
      copayMain = totalRembAmount();
    } else {
      copayMain = totalRembDisplayAmount();
    }
    
    let copayMenopur;
    if (rebateValidationFlag === 'Y') {
      copayMenopur = totalMenopurRembAmount();
    } else {
      copayMenopur = totalMenopurRembDisplayAmount();
    }

   // setMainCopayAmount(copay);
    const copay = copayMain + copayMenopur;
    console.log("Combined Copay for cost share calculation:", copay);

    //console.log("Copay for cost share calculation:", copay);
  let offer ;
  let rxCost = 0;
    let menopurCostShare = 0;
     let menopurTotal = 0;
     let totalCostShare = 0;
    if (!isKimco && !isChewy) {
    offer = await calculateCostShareDetails(copay);
    } else if (isKimco){
      let totalRembAmountValueMain;
      let totalRembAmountValueMenopur;
      if (rebateValidationFlag === 'Y'){
      totalRembAmountValueMain = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);

totalRembAmountValueMenopur = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);
      } else {
        totalRembAmountValueMain = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
totalRembAmountValueMenopur = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
      }

rxCost = totalRembAmountValueMain + totalRembAmountValueMenopur;
      offer = Math.min(40, rxCost);

//       console.log(`this the member pay for ${rowMainIndex}===============>` , memberPay);
      
//       const menopurMemberPay = menopurGridRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );
     
// const mainMemberPay = updatedMainRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );

//   const currentMemberPay = memberPay;
//   const totalMemberPayForAllRows = mainMemberPay + menopurMemberPay + currentMemberPay;


//   const drgNAme = updatedMainRows[rowMainIndex].DrugName || '';
//     console.log("Drug Name to update in combined grid: =====> ", drgNAme);

//     let index = 0;

//     for (let i = 0; i < updatedGridRows.length; i++) {
//       if (updatedGridRows[i].DrugName === drgNAme) {
//         index = i;
//         break;
//       }
//     }
//   //updatedMainRows[rowMainIndex]['Member Pays'] = parseFloat(currentMemberPay).toFixed(2); // for display
//        updatedMainRows[rowMainIndex]['Member Pays'] = parseFloat(currentMemberPay).toFixed(2); // for display
//        updatedMainRows[rowMainIndex]['Reimbursment Amount'] = parseFloat(rembAmountDisplay).toFixed(2); // for display
//   updatedGridRows[index].MemberPays = parseFloat(currentMemberPay).toFixed(2);
//     updatedGridRows[index]['Member Pays'] = parseFloat(currentMemberPay).toFixed(2);
//     updatedGridRows[index]['Disp Qty'] = dispQty;
//     updatedGridRows[index]['Cancel Qty'] = appQty - dispQty;
//     updatedGridRows[index].ReimbursementAmountDisplay = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // returns number
// updatedGridRows[index].ReimbursementAmountValue = parseFloat(Number(rembAmount || 0).toFixed(2)); // returns number
// updatedGridRows[index]['Reimbursment Amount'] = parseFloat(Number(rembAmountDisplay || 0).toFixed(2));
// console.log("TotalmemberPayForAllRows:$$$$$$$$$$$$$>>>>", totalMemberPayForAllRows);

//   const winPays = rxCost - totalMemberPayForAllRows;
//   setGridRows(updatedGridRows);
//     setTotalMemberPays(parseFloat(totalMemberPayForAllRows).toFixed(2));
//   setTotalWinPays(winPays.toFixed(2));
//   setMainGridRows(updatedMainRows);


//       console.log("[Rule] KIMCO: offer(total member pays) =", offer);
//       return;
    } else if (isChewy && isPPO){
      let totalRembAmountValueMain;
      let totalRembAmountValueMenopur;
      if (rebateValidationFlag === 'Y'){
      totalRembAmountValueMain = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);

totalRembAmountValueMenopur = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);
      } else {
        totalRembAmountValueMain = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
totalRembAmountValueMenopur = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
      }

rxCost = totalRembAmountValueMain + totalRembAmountValueMenopur;
      offer = Math.min(50, rxCost);
    } else if (isChewy && !isPPO){
      offer = 0;
    }
   // const memberPays = parseFloat(Number(offer || 0).toFixed(2));
    let currentMemberPays = 0;
    if (!isKimco && !isChewy){
    currentMemberPays = parseFloat(Number(offer || 0).toFixed(2)) - prevMemberPays ;
    } else if (isKimco){
      currentMemberPays = parseFloat(Number(offer || 0).toFixed(2)) ;
    } else if (isChewy){
      currentMemberPays = parseFloat(Number(offer || 0).toFixed(2)) ;
    }

    console.log('this is current member pays', currentMemberPays);
    
     //updatedMainRows[rowMainIndex].MemberPays = memberPays;
    //  updatedMainRows[rowMainIndex]['Member Pays'] = parseFloat(currentMemberPays).toFixed(2); // for display

     

     const totalRembAmountValueMain = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);
const totalRembAmountValueMenopur = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);

// const totalCostShareAmountValueMain = updatedMainRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );
// const totalCostShareAmountValueMenopur = menopurGridRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );

const totalCostShareAmountValueMenopur = totalMenopurCostShare;

 rxCost = totalRembAmountValueMain + totalRembAmountValueMenopur;
 menopurCostShare = totalCostShareAmountValueMenopur;
 menopurTotal = totalRembAmountValueMenopur;
 if (!isKimco && !isChewy){
 totalCostShare = offer;
 } else if (isKimco){
  const mainMemberPay = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
const menopurMemberPay = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
 totalCostShare = mainMemberPay + menopurMemberPay;
 } else if (isChewy){
  const mainMemberPay = updatedMainRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
const menopurMemberPay = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
 totalCostShare = mainMemberPay + menopurMemberPay;
  
}

  console.log(` rxCost: ${rxCost}, menopurTotal: ${menopurTotal}, totalCostShare: ${totalCostShare}, menopurCostShare: ${menopurCostShare} `);

const totalMemberPayForAllRows = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
const totalMemberPayForMenopurRows = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);

const totalCopay = parseFloat(totalMemberPayForAllRows + totalMemberPayForMenopurRows).toFixed(2);

const winPays = (Number(rxCost)- Number(menopurTotal) - Number(totalCostShare)) + Number(menopurCostShare);

// When displaying, use .toFixed(2)
console.log("Win Pays:", Number(winPays).toFixed(2)); 

   
    //updatedMainRows[rowMainIndex].WinPays = winPays;

    const drgNAme = updatedMainRows[rowMainIndex].DrugName || '';
    console.log("Drug Name to update in combined grid: =====> ", drgNAme);

    let index = 0;

    for (let i = 0; i < updatedGridRows.length; i++) {
      if (updatedGridRows[i].DrugName === drgNAme) {
        index = i;
        break;
      }
    }

    // updatedGridRows[index].MemberPays = parseFloat(currentMemberPays).toFixed(2);
    // updatedGridRows[index]['Member Pays'] = parseFloat(currentMemberPays).toFixed(2);
    updatedGridRows[index]['Disp Qty'] = dispQty;
    updatedGridRows[index]['Cancel Qty'] = appQty - dispQty;
    updatedGridRows[index].ReimbursementAmountDisplay = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // returns number
updatedGridRows[index].ReimbursementAmountValue = parseFloat(Number(rembAmount || 0).toFixed(2)); // returns number
updatedGridRows[index]['Reimbursment Amount'] = parseFloat(Number(rembAmountDisplay || 0).toFixed(2));

 console.log("Updating combined grid at index: ======>", index, updatedGridRows[index]);

    setTotalCopay(parseFloat(totalCopay).toFixed(2));
    setGridRows(updatedGridRows);
    setTotalMemberPays(parseFloat(totalCostShare).toFixed(2));
  setTotalWinPays(Number(winPays).toFixed(2));
  setTotalAmount(totalRembAmount);
  console.log("this is the updated Rows:", updatedMainRows);
  }

  setMainGridRows(updatedMainRows);
}

const handleDispQtyChangeMenopurGrid = async (value, rowId) => {
  const updatedMenopurRows = [...menopurGridRows];
  const updatedGridRows = [...gridRows];
  const isKimco = (contract?.trim() === 'Kimco Realty-Anthem-Premier');
  const isChewy = (contract?.trim() === 'Chewy-Aetna-Premier');
   //const planName = (rxData?.[0]?.PlanName || '');
    const isPPO = planType.toUpperCase().includes('PPO'); 

  const rowMenopurIndex = updatedMenopurRows.findIndex(row => row.id === rowId);
  
  if (rowMenopurIndex === -1) return;

  const dispQty = parseFloat(value || 0);
  const appQty = parseFloat(updatedMenopurRows[rowMenopurIndex].AppQty || 1);

  if (dispQty > appQty) {
    toast.error('Dispensed quantity cannot be greater than Approved quantity');
    return;
  }

  updatedMenopurRows[rowMenopurIndex].DispQty = dispQty;
  updatedMenopurRows[rowMenopurIndex]['Disp Qty'] = dispQty;
  updatedMenopurRows[rowMenopurIndex].CancelQty = appQty - dispQty;
  updatedMenopurRows[rowMenopurIndex]['Cancel Qty'] = appQty - dispQty;

  const objectForcostPharmacy = await loadRxCostPharmacy(contract, pharmCode.toString(), buildRxItemsXmlFromDispQty(updatedMenopurRows[rowMenopurIndex]));
  console.log("Cost Pharmacy Request:", contract, pharmCode.toString(), buildRxItemsXmlFromDispQty(updatedMenopurRows[rowMenopurIndex]));
  setCostPharmacyData(objectForcostPharmacy);

  setRx_Cost_Before_CostShare(objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0);
  setPharmacy_Reimb_Amt_Before_CostShare(objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0);

  const displayValueRembAmount = objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
  const valueRembAmount = rebateValidationFlag === 'Y'
  ? objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0 : 
  objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;

    const prevMemberPays = parseFloat(totalMemberPays).toFixed(2);


   if (
    ((rxData[0]?.ContractType?.trim() === 'Premier' || 
    contract === "Moelis-Cigna-Premier Rx" )&& accumAccess === 'Y') 
  ) {
   
    const rembAmount = valueRembAmount; 
    const rembAmountDisplay = displayValueRembAmount;


updatedMenopurRows[rowMenopurIndex].ReimbursementAmountDisplay = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // for display
updatedMenopurRows[rowMenopurIndex].ReimbursementAmountValue = parseFloat(Number(rembAmount || 0).toFixed(2)); // for copay calculation
updatedMenopurRows[rowMenopurIndex]['Reimbursment Amount'] = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // for display
   


    let totalRembDisplayAmount = () => { 
      let value = 0;
      for (let i = 0; i < updatedMenopurRows.length; i++) {
        let currentRowValue = parseFloat(updatedMenopurRows[i].ReimbursementAmountDisplay || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }
    console.log("Total Reimbursement Display Amount:", totalRembDisplayAmount());


    
    let totalRembAmount = () => { 
      let value = 0;
      for (let i = 0; i < updatedMenopurRows.length; i++) {
        let currentRowValue = parseFloat(updatedMenopurRows[i].ReimbursementAmountValue || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }

    let totalMainRembDisplayAmount = () => { 
      let value = 0;
      for (let i = 0; i < mainGridRows.length; i++) {
        let currentRowValue = parseFloat(mainGridRows[i].ReimbursementAmountDisplay || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }
    console.log("Total Reimbursement Display Amount:", totalRembDisplayAmount());


    
    let totalMainRembAmount = () => { 
      let value = 0;
      for (let i = 0; i < mainGridRows.length; i++) {
        let currentRowValue = parseFloat(mainGridRows[i].ReimbursementAmountValue || 0);
        value += currentRowValue;
      }
      return parseFloat(Number((value).toFixed(2)));
    }

    // Use this total for your copay calculation
    let menopurCopay;
    let mainCopay;
    

    if (rebateValidationFlag === 'Y') {
      menopurCopay = totalRembAmount();
    } else {
      menopurCopay = totalRembDisplayAmount();
    }

    if (rebateValidationFlag === 'Y') {
      mainCopay = totalMainRembAmount();
    } else {
      mainCopay = totalMainRembDisplayAmount();
    }

    //setMenopurCopayAmount(copay);
    const copay = menopurCopay + mainCopay;
    console.log("Combined Copay for cost share calculation:", copay);
    //console.log("Copay for cost share calculation:", copay);
    let offer ;
    let menopurOffer = 0;
  let rxCost = 0;
    let menopurCostShare = 0;
     let menopurTotal = 0;
     let totalCostShare = 0;

    if (!isKimco && !isChewy) {
    offer = await calculateCostShareDetails(copay);
    menopurOffer = await calculateCostShareDetails(menopurCopay);
    } else if (isKimco){
      let totalRembAmountValueMain;
      let totalRembAmountValueMenopur;
      if (rebateValidationFlag === 'Y'){
      totalRembAmountValueMain = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);

totalRembAmountValueMenopur = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);
      } else {
        totalRembAmountValueMain = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
totalRembAmountValueMenopur = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
      }

rxCost = totalRembAmountValueMain + totalRembAmountValueMenopur;
      offer = Math.min(40, rxCost);

//       console.log(`this the member pay for ${rowMenopurIndex}===============>` , memberPay);
      
//       const menopurMemberPay = updatedMenopurRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );
     
// const mainMemberPay = mainGridRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );

//   offer = memberPay;
//   const totalMemberPayForAllRows = mainMemberPay + menopurMemberPay + currentMemberPay;


//   const drgNAme = updatedMenopurRows[rowMenopurIndex].DrugName || '';
//     console.log("Drug Name to update in combined grid: =====> ", drgNAme);

//     let index = 0;

//     for (let i = 0; i < updatedGridRows.length; i++) {
//       if (updatedGridRows[i].DrugName === drgNAme) {
//         index = i;
//         break;
//       }
//     }
//   //updatedMainRows[rowMainIndex]['Member Pays'] = parseFloat(currentMemberPay).toFixed(2); // for display
//        updatedMenopurRows[rowMenopurIndex]['Member Pays'] = parseFloat(currentMemberPay).toFixed(2); // for display
//        updatedMenopurRows[rowMenopurIndex]['Reimbursment Amount'] = parseFloat(rembAmountDisplay).toFixed(2); // for display
//   updatedGridRows[index].MemberPays = parseFloat(currentMemberPay).toFixed(2);
//     updatedGridRows[index]['Member Pays'] = parseFloat(currentMemberPay).toFixed(2);
//     updatedGridRows[index]['Disp Qty'] = dispQty;
//     updatedGridRows[index]['Cancel Qty'] = appQty - dispQty;
//     updatedGridRows[index].ReimbursementAmountDisplay = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // returns number
// updatedGridRows[index].ReimbursementAmountValue = parseFloat(Number(rembAmount || 0).toFixed(2)); // returns number
// updatedGridRows[index]['Reimbursment Amount'] = parseFloat(Number(rembAmountDisplay || 0).toFixed(2));
// console.log("TotalmemberPayForAllRows:$$$$$$$$$$$$$>>>>", totalMemberPayForAllRows);

// const totalReimbursementMenopurValue = updatedMenopurRows.reduce(
//   (sum, row) => sum + parseFloat(row['Reimbursment Amount'] || 0),
//   0
// );  
// const menopurRembValue = totalReimbursementMenopurValue - menopurMemberPay;

//  // const winPays = rxCost - totalMemberPayForAllRows;
//   setGridRows(updatedGridRows);
//     setTotalMemberPays(parseFloat(totalMemberPayForAllRows).toFixed(2));
//     setWinCardAmount(parseFloat(menopurRembValue).toFixed(2));
//   //setTotalWinPays(winPays.toFixed(2));
//   setMenopurGridRows(updatedMenopurRows);


//       console.log("[Rule] KIMCO: offer(total member pays) =", offer);
//       return;
    } else if (isChewy && isPPO){
      let totalRembAmountValueMain;
      let totalRembAmountValueMenopur;
      if (rebateValidationFlag === 'Y'){
      totalRembAmountValueMain = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);

totalRembAmountValueMenopur = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);
      } else {
        totalRembAmountValueMain = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
totalRembAmountValueMenopur = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.ReimbursementAmountValue || 0),
  0
);
      }

rxCost = totalRembAmountValueMain + totalRembAmountValueMenopur;
      offer = Math.min(50, rxCost);
      menopurOffer = Math.min(50, menopurCopay);

    } else if (isChewy && !isPPO){
      offer = 0;
    }
    let currentMemberPays = 0;
    if (!isKimco && !isChewy){
    currentMemberPays = parseFloat(Number(menopurOffer || 0).toFixed(2)) ;
    } else if (isKimco){
      currentMemberPays = parseFloat(Number(offer || 0).toFixed(2)) ;
    } else if (isChewy){
      currentMemberPays = parseFloat(Number(offer || 0).toFixed(2)) ;
      }

    console.log('this is current member pays', currentMemberPays);
      // updatedMenopurRows[rowMenopurIndex]['Member Pays'] = currentMemberPays; // for display

      

   const totalRembAmountValueMain = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);
const totalRembAmountValueMenopur = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.['ReimbursementAmountDisplay'] || 0),
  0
);

// const totalCostShareAmountValueMain = mainGridRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );
const totalCostShareAmountValueMenopur = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);

 rxCost = totalRembAmountValueMain + totalRembAmountValueMenopur;
 menopurCostShare = menopurOffer;
 console.log("menopurCostShare:::::::::::>", menopurCostShare);
 menopurTotal = totalRembAmountValueMenopur;
 if (!isKimco && !isChewy){
 totalCostShare = offer;
 } else if (isKimco){
  const mainMemberPay = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
const menopurMemberPay = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
 totalCostShare = mainMemberPay + menopurMemberPay;
 } else if (isChewy){
  const mainMemberPay = updatedMenopurRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
const menopurMemberPay = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
 totalCostShare = offer;
  
}

 console.log(` rxCost: ${rxCost}, menopurTotal: ${menopurTotal}, totalCostShare: ${totalCostShare}, menopurCostShare: ${menopurCostShare} `);

const totalMemberPayForAllRows = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
const totalMemberPayForMenopurRows = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0 
);

const totalCopay = parseFloat(totalMemberPayForAllRows + totalMemberPayForMenopurRows).toFixed(2);

const winPays = (Number(rxCost) - Number(menopurTotal) - Number(totalCostShare)) + Number(menopurCostShare);
const winCardValueRaw = Number(menopurTotal) - Number(menopurCostShare);
const winCardValue = isNaN(winCardValueRaw) ? 0 : parseFloat(winCardValueRaw.toFixed(2));


// When displaying, use .toFixed(2)
console.log("Win Pays:", Number(winPays.toFixed(2)));

//updatedMenopurRows[rowMenopurIndex].WinPays = winPays;

const drgNAme = updatedMenopurRows[rowMenopurIndex].DrugName || '';
    console.log("Drug Name to update in combined grid: =====> ", drgNAme);

let index = 0;

    for (let i = 0; i < updatedGridRows.length; i++) {
      if (updatedGridRows[i].DrugName === drgNAme) {
        index = i;
        break;
      }
    }

    // updatedGridRows[index].MemberPays = parseFloat(currentMemberPays).toFixed(2);
    // updatedGridRows[index]['Member Pays'] = parseFloat(currentMemberPays).toFixed(2);
    updatedGridRows[index]['Disp Qty'] = dispQty;
    updatedGridRows[index]['Cancel Qty'] = appQty - dispQty;
    updatedGridRows[index].ReimbursementAmountDisplay = parseFloat(Number(rembAmountDisplay || 0).toFixed(2)); // returns number
updatedGridRows[index].ReimbursementAmountValue = parseFloat(Number(rembAmount || 0).toFixed(2)); // returns number
updatedGridRows[index]['Reimbursment Amount'] = parseFloat(Number(rembAmountDisplay || 0).toFixed(2));

 console.log("Updating combined grid at index: ======>", index, updatedGridRows[index]);

   
    setGridRows(updatedGridRows);

    setTotalMenopurCostShare(parseFloat(menopurOffer).toFixed(2));
    setTotalCopay(parseFloat(totalCopay).toFixed(2));
    setTotalMemberPays(parseFloat(totalCostShare).toFixed(2));
  setTotalWinPays(winPays.toFixed(2));
  setWinCardAmount(winCardValue.toFixed(2));
  setTotalAmount(totalRembAmount);
  console.log("this is the updated Rows:", updatedMenopurRows);
  }

  setMenopurGridRows(updatedMenopurRows);
}


 
// handle Disp Qty Change for Premier
const handleDispQtyChangePremier = async (value, rowId) => {
  const updatedRows = [...gridRows];
  const rowIndex = updatedRows.findIndex(row => row.id === rowId);
  if (rowIndex === -1) return;

  const dispQty = parseFloat(value || 0);
  const appQty = parseFloat(updatedRows[rowIndex].AppQty || 1);

  if (dispQty > appQty) {
    toast.error('Dispensed quantity cannot be greater than Approved quantity');
    return;
  }

  updatedRows[rowIndex].DispQty = dispQty;
  updatedRows[rowIndex]['Disp Qty'] = dispQty;
  updatedRows[rowIndex].CancelQty = appQty - dispQty;
  updatedRows[rowIndex]['Cancel Qty'] = appQty - dispQty;

  if (accumAccess === 'Y') {

  const objectForcostPharmacy = await loadRxCostPharmacy(contract, pharmCode.toString(), buildRxItemsXmlFromDispQty(updatedRows[rowIndex]));
  console.log("Cost Pharmacy Request:", contract, pharmCode.toString(), buildRxItemsXmlFromDispQty(updatedRows[rowIndex]));
  setCostPharmacyData(objectForcostPharmacy);
  setRx_Cost_Before_CostShare(objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0);
  setPharmacy_Reimb_Amt_Before_CostShare(objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0);
  const displayValueRembAmount = objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;
  
  const valueRembAmount = rebateValidationFlag === 'Y'
  ? objectForcostPharmacy?.Rx_Cost_Before_CostShare || 0
  : objectForcostPharmacy?.Pharmacy_Reimb_Amt_Before_CostShare || 0;

  const prevMemberPays = totalMemberPays;


  if (
    (rxData?.ContractType?.trim() === 'Premier' && accumAccess === 'Y') ||
    (rxData[0]?.ContractType && rxData[0]?.ContractType?.trim() === 'Premier' && accumAccess === 'Y') ||
    (contract === "Moelis-Cigna-Premier Rx" && accumAccess === 'Y' ) 
  ) {
   // const reimbursement = await calculateReimbursementAmount(dispQty, updatedRows[rowIndex].PresID);
    const rembAmount = valueRembAmount; 
    const rembAmountDisplay = displayValueRembAmount;


updatedRows[rowIndex].ReimbursementAmountDisplay = parseFloat(rembAmountDisplay || 0).toFixed(2); // for display
updatedRows[rowIndex].ReimbursementAmountValue = parseFloat(rembAmount || 0).toFixed(2); // for copay calculation
updatedRows[rowIndex]['Reimbursment Amount'] = parseFloat(rembAmountDisplay || 0).toFixed(2); // for display
   
// Now, recalculate the total using the updatedRows (which includes the just-updated row)
    // const totalRembAmount = updatedRows.reduce(
    //   (sum, row) => sum + parseFloat(row.ReimbursementAmount || 0),
    //   0
    // ).toFixed(2);

    let totalRembDisplayAmount = () => { 
      let value = 0;
      for (let i = 0; i < gridRows.length; i++) {
        let currentRowValue = parseFloat(updatedRows[i].ReimbursementAmountDisplay || 0);
        value += currentRowValue;
      }
      return value.toFixed(2);
    }
    console.log("Total Reimbursement Display Amount:", totalRembDisplayAmount());


    

    // Use this total for your copay calculation
    let totalRembAmount = () => { 
      let value = 0;
      for (let i = 0; i < gridRows.length; i++) {
        let currentRowValue = parseFloat(updatedRows[i].ReimbursementAmountValue || 0);
        value += currentRowValue;
      }
      return value.toFixed(2);
    }

    // Use this total for your copay calculation
    let copay;
    let singleCopay = parseFloat( rembAmount || 0);

    if (rebateValidationFlag === 'Y') {
      copay = totalRembAmount();
    } else {
      copay = totalRembDisplayAmount();
    }

    

    console.log("Copay for cost share calculation:", copay);
    console.log("Single row copay for cost share calculation:", singleCopay);
  let offer = 0;
  const isKimco = (contract?.trim() === 'Kimco Realty-Anthem-Premier');
  const isChewy = (contract?.trim() === 'Chewy-Aetna-Premier');
   const isPPO = planType.toUpperCase().includes('PPO'); 

if (!isKimco && !isChewy) {
     offer = await calculateCostShareDetails(copay);

}
else if (isKimco){
 offer = Math.min(40, copay);
} else if (isChewy && isPPO){
    
 
      offer = Math.min(50, copay);

    } else if (isChewy && !isPPO){
      offer = 0;
    }    //const singleOffer = await calculateSingleCostShareDetails(singleCopay);

    // const offerSingle = await calculateCostShareDetails(singleCopay);
    console.log("Cost Share Offer for single row:", offer);

    //const memberPays = parseFloat(offer || 0).toFixed(2);
    // updatedRows[rowIndex].MemberPays = memberPays;
     //updatedRows[rowIndex]['Member Pays'] = memberPays; // for display

    // const totalMemberPayForAllRows = updatedRows.reduce(
    //   (sum, row) => sum + parseFloat(row.MemberPays || 0), 0).toFixed(2);

    const currentCopay = parseFloat(offer - prevMemberPays || 0);

   
      // updatedRows[i].MemberPays = parseFloat(totalMemberPayForAllRows || 0).toFixed(2);
     // updatedRows[rowIndex]['Member Pays'] = parseFloat( currentCopay ||  0).toFixed(2); // for display


    const winPays = (totalRembDisplayAmount() - offer).toFixed(2);
    console.log("Win Pays:", winPays);  

   
    updatedRows[rowIndex].WinPays = winPays;

    const totalMemberPayForAllRows = gridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);
// const totalMemberPayForMenopurRows = menopurGridRows.reduce(
//   (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
//   0
// );

const totalCopay = parseFloat(totalMemberPayForAllRows).toFixed(2);

   
    setTotalCopay(parseFloat(totalCopay).toFixed(2)); 
    setTotalMemberPays(offer);
  setTotalWinPays(winPays);
  setTotalAmount(totalRembAmount);
  console.log("this is the updated Rows:", updatedRows);
  }} else {
   // if (updatedRows[rowIndex]?.DropDown !== 'Yes') {
    updatedRows[rowIndex].ReimbursementAmountDisplay = dispQty * parseFloat(updatedRows[rowIndex]['Unit Price'] || 0).toFixed(2); // for display
    updatedRows[rowIndex].ReimbursementAmountValue = dispQty * parseFloat(updatedRows[rowIndex]['Unit Price'] || 0).toFixed(2); // for copay calculation
    updatedRows[rowIndex]['Reimbursment Amount'] = dispQty * parseFloat(updatedRows[rowIndex]['Unit Price'] || 0).toFixed(2); // for display

    const totalRembAmount = updatedRows.reduce(
      (sum, row) => sum + parseFloat(row.ReimbursementAmountDisplay || 0),
      0
    ).toFixed(2); 

    const totalMemberPayForAllRows = gridRows.reduce(
  (sum, row) => sum + parseFloat(row?.['Member Pays'] || 0),
  0
);

  const totalCopay = parseFloat(totalMemberPayForAllRows).toFixed(2);

   
    setTotalCopay(parseFloat(totalCopay).toFixed(2)); 
    setTotalWinPays(totalRembAmount);
  
  }
  // else if (updatedRows[rowIndex]?.DropDown === 'Yes') {
  //   const drugName = updatedRows[rowIndex]?.DrugName || '';
  //   const drugInfo = rxData?.DrugInfos;
  //   const matchedDrug = drugInfo?.find(drug, prp => drug.DrugName === drugName && parseFloat(drug.PRP) > 0);
  //   console.log("Matched Drug for DropDown 'Yes':", matchedDrug);

  // }
 // } 

  setGridRows(updatedRows);


};

//handle Disp Qty Change for HMOI

const handleDispQtyChangeHMOI = (val, rowId) => {
  const updated = gridRows.map(row => {
    if (row.id === rowId) {
      const drugInfos = rxData?.DrugInfos || [];
      const matchingDrugs = drugInfos.filter(d => d.NDC === row.NDC);
      
      // Take highest PRP if available, else fallback to Unit Price from prescription row
      let prp = 0;
      let highestPRPDrug = {};

      if (matchingDrugs.length > 0) {
        highestPRPDrug = matchingDrugs.reduce(
          (prev, curr) => parseFloat(curr.PRP) > parseFloat(prev.PRP) ? curr : prev,
          { PRP: 0 }
        );
        prp = parseFloat(highestPRPDrug.PRP || 0);
      } else {
        prp = parseFloat(row['Unit Price'] || row.UnitPrice || 0); // fallback
      }

      const appQty = parseFloat(row.AppQty ?? 0);
      const dispQty = parseFloat(val ?? 0);
      const cancelQty = dispQty ? appQty - dispQty : '';
      const amount = dispQty ? (dispQty * prp).toFixed(2) : '';

      if (dispQty > appQty) {
  toast.error('Dispensed quantity cannot be greater than Approved quantity');
  return row; // Always return the row object
}

      return {
        ...row,
        PRP: prp,
        DrugName: highestPRPDrug.DrugName || row.DrugName,
        GPIName: highestPRPDrug.GPIName || row.GPIName,
        Effdt: highestPRPDrug.Effdt
          ? new Date(highestPRPDrug.Effdt).toLocaleDateString()
          : '—',
        DispQty: dispQty,
        ['Disp Qty']: dispQty,
        CancelQty: cancelQty,
        ['Cancel Qty']: cancelQty,
        Amount: amount,
        ReimbursementAmount: amount,
        ['Reimbursment Amount']: amount, // for display
        VendorAuth: medicalAuth || "",
        PharmacyAuth: cignaRXAuth || ""

      };
    }
    return row;
  });

  setGridRows(updated);

  // Recalculate total after update
  const total = updated.reduce((sum, r) => sum + parseFloat(r.Amount || 0), 0).toFixed(2);
  setTotalAmount(total);
  setTotalWinPays(total);
};


// handle Disp Qty Change for Non-Premier

const handleDispQtyChangeNonPremier = (val, rowId) => {
  const updated = gridRows.map(row => {
    if (row.id === rowId) {
      const appQty = parseFloat(row.AppQty || 0);
      const dispQty = parseFloat(val || 0);

      if (dispQty > appQty) {
        toast.error('Dispensed quantity cannot be greater than Approved quantity');
        return row;
      }

      const cancelQty = appQty - dispQty;


      return {
        ...row,
         DispQty: dispQty,
        ['Disp Qty']: dispQty,
        CancelQty: cancelQty,
        ['Cancel Qty']: cancelQty,
        //Amount: amount,
        //ReimbursementAmount: amount
      };
    }
    return row;
  });

  setGridRows(updated);

  // Optional: recalculate total
 // const total = updated.reduce((sum, row) => sum + parseFloat(row.ReimbursementAmount || 0), 0).toFixed(2);
 // setTotalAmount(total);
};

// handle disp Qty for dtc/ rx contracts

// const handleDispQtyChangeDTCRX = () => {
//   const data = rxData?.Prescriptions || [];
//   console.log("Data for DTC/RX:", data);
//   gridRows.forEach((row, index) => {
//     const matchingPrescription = data.find(pres => pres.PresID === row.PresID);
//     if (matchingPrescription) {
//       const dispQty = parseFloat(matchingPrescription.DispQty || 0);
//       const appQty = parseFloat(matchingPrescription.AppQty || 0);
//       const cancelQty = appQty - dispQty;
//       const amount = dispQty * parseFloat(row.PRP || 0);

//       const updatedRow = {
//         ...row,
//         DispQty: dispQty,
//         CancelQty: cancelQty,
//         Amount: amount.toFixed(2),
//         ReimbursementAmount: amount.toFixed(2)
//       };

//       setGridRows(prevRows => {
//         const newRows = [...prevRows];
//         newRows[index] = updatedRow;
//         return newRows;
//       });
//     }
//   })
// }


// calculate the costshare details member concern true




// calculate the costshare details
const calculateCostShareDetails = async (copay) => {
  
  try {
    const firstTaskDetail = rxData?.[0] || (Array.isArray(rxData?.TaskDetail) ? rxData.TaskDetail[0] : undefined) || {};
const memberID = rxData?.MemberID || firstTaskDetail.MemberID || '';
  const authNo = rxData?.AuthNo || firstTaskDetail.AuthNo || '';
const priorityID = rxData?.PriorityID || firstTaskDetail.PriorityID || '';
const schStartDate = rxData?.SchStartDate || firstTaskDetail.SchStartDate || '';
const schEndDate = rxData?.SchEndDate || firstTaskDetail.SchEndDate || '';
const rxDataPrescriptions = rxData?.Prescriptions || [];

const drugCount = calculateDrugCount(rxDataPrescriptions);
console.log("This is the Drug Count:", drugCount);

console.log("prescription for cost share calculation:", rxDataPrescriptions);

console.log(`Member ID:, ${memberID} Auth No: ${authNo} priorityID: ${priorityID} schStartDate: ${schStartDate} schEndDate: ${schEndDate}`);

const value = await loadRXCostshareDetails(contract,memberID, userId, authNo, 
      copay, taskId, 'N',  drugCount
      );
// const singleValue = await loadRXCostshareDetails(contract,memberID, userId, authNo, 
//       singleCopay, taskId, 'N',  drugCount
//       );

      let result;

// Safely access the response data
if (value.success && Array.isArray(value?.data?.Detail)) {
  for (const item of value?.data?.Detail) {
    if (item.var_name === "memb_cost_share") {
      result = item;
      break;
    }
  }
} else {
  console.error("Unexpected data format or failed response:", value);
}

//       let singleResult;

// // Safely access the response data
// if (singleValue.success && Array.isArray(singleValue?.data?.Detail)) {
//   for (const item of singleValue?.data?.Detail) {
//     if (item.var_name === "memb_cost_share") {
//       singleResult = item;
//       break;
//     }
//   }
// } else {
//   console.error("Unexpected data format or failed response:", singleValue);
// }

console.log("DEduction array ====>", value?.data?.Detail);
//console.log("DEduction Single Value array ====>", singleValue?.data?.Detail);


      console.log("needed result", result?.DeductionValue); 
      const offerAmount = result?.DeductionValue || '0.00';
      //const singleOfferAmount = singleResult?.DeductionValue || '0.00';
      console.log("Offer Amount:", offerAmount); 

    //setSingleRowOfferAmount(result?.DeductionValue || '0.00');
    
    console.log(`Calculated Copay:  ${copay}`);

   {/* and Total Amount: ${totalAmount}*/}
   return offerAmount;

  }catch (error) { 
    console.error("Error calculating cost share details:", error);
    toast.error('Failed to calculate cost share details');
  };
}

const calculateSingleCostShareDetails = async (singleCopay) => {
  
  try {
    const firstTaskDetail = rxData?.[0] || (Array.isArray(rxData?.TaskDetail) ? rxData.TaskDetail[0] : undefined) || {};
const memberID = rxData?.MemberID || firstTaskDetail.MemberID || '';
  const authNo = rxData?.AuthNo || firstTaskDetail.AuthNo || '';
const priorityID = rxData?.PriorityID || firstTaskDetail.PriorityID || '';
const schStartDate = rxData?.SchStartDate || firstTaskDetail.SchStartDate || '';
const schEndDate = rxData?.SchEndDate || firstTaskDetail.SchEndDate || '';
const rxDataPrescriptions = rxData?.Prescriptions || [];

const drugCount = calculateDrugCount(rxDataPrescriptions);
console.log("This is the Drug Count:", drugCount);

console.log("prescription for cost share calculation:", rxDataPrescriptions);

console.log(`Member ID:, ${memberID} Auth No: ${authNo} priorityID: ${priorityID} schStartDate: ${schStartDate} schEndDate: ${schEndDate}`);

// const value = await loadRXCostshareDetails(contract,memberID, userId, authNo, 
//       copay, taskId, 'N',  drugCount
//       );
const singleValue = await loadRXCostshareDetails(contract,memberID, userId, authNo, 
      singleCopay, taskId, 'N',  drugCount
      );

//       let result;

// // Safely access the response data
// if (value.success && Array.isArray(value?.data?.Detail)) {
//   for (const item of value?.data?.Detail) {
//     if (item.var_name === "memb_cost_share") {
//       result = item;
//       break;
//     }
//   }
// } else {
//   console.error("Unexpected data format or failed response:", value);
// }

      let singleResult;

// Safely access the response data
if (singleValue.success && Array.isArray(singleValue?.data?.Detail)) {
  for (const item of singleValue?.data?.Detail) {
    if (item.var_name === "memb_cost_share") {
      singleResult = item;
      break;
    }
  }
} else {
  console.error("Unexpected data format or failed response:", singleValue);
}

//console.log("DEduction array ====>", value?.data?.Detail);
console.log("DEduction Single Value array ====>", singleValue?.data?.Detail);


      //console.log("needed result", result?.DeductionValue); 
      //const offerAmount = result?.DeductionValue || '0.00';
      const singleOfferAmount = singleResult?.DeductionValue || '0.00';
      console.log("singleOffer Amount: ===>", singleOfferAmount); 

    //setSingleRowOfferAmount(result?.DeductionValue || '0.00');
    
    console.log(`Calculated Copay:  ${singleCopay}`);

   {/* and Total Amount: ${totalAmount}*/}
   return singleOfferAmount;

  }catch (error) { 
    console.error("Error calculating cost share details:", error);
    toast.error('Failed to calculate cost share details');
  };
}

//   useEffect(() => {
//   const runCostShareCalc = async () => {
//     if (rxData?.ContractType?.trim() === 'Premier') {
//       await calculateCostShareDetails();
//     }
//   };

//   runCostShareCalc();
// }, [gridRows, rxData?.ContractType, contract, rebateValidationFlag]);


  // helper function to convert file to base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data URL prefix
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  //  const handleFileDisplay = async (file) => {
  //   if (!file) return;
  //   const base64 = await fileToBase64(file);
  //   const memberID = rxData[0]?.MemberID || rxData?.MemberID || '';
  //   const ext = file.slice(file.lastIndexOf('.')).toLowerCase();
  //   let docType;
  //   if (ext === '.pdf') {
  //         docType = 'PDF';
  //       } else if (ext === '.tif' || ext === '.tiff') {
  //         docType = 'TIFF';
  //       }
  // try{
  //  const response =  await getOpenOrdersFile(memberID, file, contract, docType, base64);
  //   if (response) {
  //     window.open(response, '_blank', 'noopener,noreferrer');
  //   }
  // } catch (error) {
  //   console.error("Error fetching file:", error);
  //   toast.error('Failed to fetch file');
  // }
   
  //  }

   const handleFileDisplay = async (file, bytes) => {
  if (!file) return;

  let fileName = typeof file === 'string' ? file : file.name;
  const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
  const docType = 'Prescription';
  const memberID = rxData[0]?.MemberID;

  const base64 = bytes;

  
    try {
      const response = await getOpenOrdersFile(memberID, fileName, contract, docType, base64); // Pass null or omit base64
      if (response) {
        window.open(response, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error("Error fetching file:", error);
      toast.error('Failed to fetch file');
    }
    return ;
  
};




    // submit handler

  const handleSubmit = async () => {
    try {
      // 1. Check if any DispQty is invalid
      const invalidDispQty = gridRows.some(row => {
  let dispQty = row.DispQty || row['Disp Qty'];
  // For "Other Drugs", use AppQty as default if DispQty is not set
  if (
    row.DrugName === 'Other Drugs' &&
    (dispQty === undefined || dispQty === null || dispQty === '')
  ) {
    dispQty = row.AppQty;
  }
  return (
    dispQty === undefined ||
    dispQty === null ||
    dispQty === '' ||
    isNaN(dispQty) ||
    isNaN(Number(dispQty)) ||
    Number(dispQty) < 0
  );
});

      if (invalidDispQty) {
        toast.error('Please enter Disp Qty for all prescriptions');
        return;
      }

      // 2. Check if all Reason fields are filled

      const invalidCancelRows = gridRows.filter(
  (row) => Number( row['Cancel Qty']) > 0 && (!row.Reason || row.Reason.trim() === '')
);

if (invalidCancelRows.length > 0) {
  toast.error("Please select the reason to cancel the drug");
  return;
}


      await editOrderDetails({
        rxData: { TaskDetail: rxData },
        gridRows,
        userId,
        taskId,
        contract,
        shippingCarrier,
        trackingNumber, 
        DispQty: gridRows.reduce((sum, row) => sum + (parseFloat(row.DispQty) || 0), 0),
        ['Cancel Qty']: gridRows.reduce((sum, row) => sum + (parseFloat(row.CancelQty) || 0), 0),
        VendorPharmacyAuth:rxData[0]?.PharmacyAuth || '',
        VendorAuth:  rxData[0]?.VendorAuth || ''
      });
        console.log("Order details updated successfully");
        console.log("Grid Rows:", gridRows);

      if ((!shippingCarrier || !trackingNumber) 
        && (contract === "HMO Illinois"||  contract === "Moelis-Cigna-Premier Rx" 
      || contract === "WINFertilityRx"  || contract === 'WINFertility DTC' || (rxData.ContractType && rxData.ContractType.trim() !== '') || 
    (rxData[0]?.ContractType && rxData[0]?.ContractType.trim() !== '') )
      ) {

        await editOrderDetails({
        rxData: { TaskDetail: rxData },
        gridRows,
        userId,
        taskId,
        contract,
        shippingCarrier,
        trackingNumber, 
        DispQty: gridRows.reduce((sum, row) => sum + (parseFloat(row.DispQty) || 0), 0),
        ['Cancel Qty']: gridRows.reduce((sum, row) => sum + (parseFloat(row.CancelQty) || 0), 0),
      });
        console.log("Order details updated successfully");
        console.log("Grid Rows:", gridRows);

        console.log(`reimbursement amount: ${Rx_Cost_Before_CostShare} Pharmacy Reimb Amt: ${Pharmacy_Reimb_Amt_Before_CostShare} `);
        setShowTrackingModal(true);
        return;
      }else {

        setShowSummary(true);
        console.log("Order details submitted successfully");
      }


    } catch (err) {
      console.error('Error submitting order:', err);
      toast.error('Failed to submit order');
      navigate('/error-page');
    }
  }

  // onConfirm logic for tracking modal
  const handleModalConfirm =  async () => {
    setShowTrackingModal(false);
    try {
      
      setIsSubmitting(true);

    // const contract = rxData?.Contract || rxData?.TaskDetail?.Contract;
    //const taskID = taskId || rxData?.TaskDetail?.TaskID;
    const firstTaskDetail = rxData?.[0] || (Array.isArray(rxData?.TaskDetail) ? rxData.TaskDetail[0] : undefined) || {};
const memberID = rxData?.MemberID || firstTaskDetail.MemberID || '';
  const authNo = rxData?.AuthNo || firstTaskDetail.AuthNo || '';
const priorityID = rxData?.PriorityID || firstTaskDetail.PriorityID || '';
const schStartDate = rxData?.SchStartDate || firstTaskDetail.SchStartDate || '';
const schEndDate = rxData?.SchEndDate || firstTaskDetail.SchEndDate || '';
const contractType = rxData?.ContractType || firstTaskDetail.ContractType || '';
 console.log(`Member ID:, ${memberID} Auth No: ${authNo} priorityID: ${priorityID} schStartDate: ${schStartDate} schEndDate: ${schEndDate} 
  reimbursementAmount: ${totalReimbursement} `);
    if (!contract || !taskId || !memberID) {
      toast.error("Missing required prescription data. Cannot proceed.");
      return;
    }

    let costPharmacyValue;
    const costPharmacyObject = costPharmacyData;
    const drugCount = calculateDrugCount(rxData?.Prescriptions || []);

    if (rebateValidationFlag === 'Y') {
      costPharmacyValue = costPharmacyData?.Rx_Cost_Before_CostShare;
    }else if (rebateValidationFlag === 'N') {
      costPharmacyValue = costPharmacyData?.Pharmacy_Reimb_Amt_Before_CostShare;
    }

  //   const isSingleMenopurClaim =
  // gridRows.length === 1 &&
  // gridRows[0]?.DrugName === 'MENOPUR INJ 75 IU' &&
  // totalMemberPays > 0;
  
  // console.log("Is Single Menopur Claim:", isSingleMenopurClaim);
  console.log(gridRows.length , gridRows[0]?.DrugName , totalMemberPays);
    let ResultCostShareObj;
    if (contract && (contractType === 'Premier' || contract === 'Moelis-Cigna-Premier Rx')
     && (
    Number(totalMemberPays) > 0 ||
    gridRows.length !== 1 ||
    gridRows[0]?.DrugName !== 'MENOPUR INJ 75 IU'
  ) ) {
      ResultCostShareObj = await saveRXCostshareDetails(
        taskId,
        contract,
        memberID,
        userId,
        authNo,
        pharmReimbwithRebate,
        rebateValidationFlag,
        pharmReimbWithoutRebate,
        drugCount,
        );
      console.log("Cost Share Details:::::::::>", ResultCostShareObj);
    }
  
    setIsSubmitting(true);

      for (const row of gridRows) {
        const drugPayload = {
          Loop: 1,
          Flag: "Submit",
          Contract: contract,
          PharmacyID: pharmacyId,
          TaskID: taskId,
          LineID: row?.PresID?.toString() || "", 
          NDC: row?.NDC,
          DispQty: row?.DispQty || row?.['Disp Qty'], // dispensed quantity
         // Copay: 0, //member pay for premier
         // Amount: parseFloat(row?.ReimbursementAmount || 0), // reimbursement amount
          Copay: parseFloat(row?.['Member Pays']),
          Amount: parseFloat(row?.ReimbursementAmountDisplay || row?.ReimbursementAmount
            || row?.['Reimbursment Amount'] || 0),
          TaskType: "",
          UserID: userId,
          ScheduleStartDate: schStartDate,
          ScheduleEndDate: schEndDate,
          Message: notes || "",
          MemberID: memberID,
          AuthNo: authNo,
          //TotCoPay: 0,// member pay return as $ replace $ trim it double
         // TotAmount: parseFloat(totalAmount), // reimbursement amount $ replace double
          TotCoPay: parseFloat(totalCopay || 0),  // total member cost share
          TotAmount: parseFloat(totalWinPays || 0), // total reimbursement
          PriorityID: priorityID,
          ShippingCarrier: shippingCarrier || "",
          TrackingNo: trackingNumber || "",
          Notes: shippingNotes || "",
          Reason: row?.Reason || "",
        //   RebateAmount: 0,
          //WithWinMarginWithoutRebate: 0,// cost before cost share
         // WintoPharmAmt: parseFloat(row?.Amount || 0) - 0// 
          WithWinMarginWithoutRebate: parseFloat(row?.ReimbursementAmountValue || 0),
          WintoPharmAmt: parseFloat(row?.ReimbursementAmountDisplay|| 0)
        };
        await savePrescription(drugPayload);
      }
  
      // Submit task-level summary (Loop = 0)
      const taskPayload = {
        Loop: 0,
        Flag: "Submit",
        Contract: contract,
        PharmacyID: pharmacyId,
        TaskID: taskId,
        LineID: "",
        NDC: "",
        DispQty: 0,
        //Copay: 0,//conver to double 0.00
         Copay: parseFloat(totalCopay || 0),
        Amount: parseFloat(totalAmount) || 0, // Ensure totalAmount is a number 0.00      
        TaskType: "",
        UserID: userId,
        ScheduleStartDate: schStartDate,
          ScheduleEndDate: schEndDate,
        Message: notes || "",
        MemberID: memberID,
        AuthNo: authNo,
        TotCoPay: parseFloat(totalCopay || 0), // member pay return as $ replace $ trim it double
        TotAmount: parseFloat(totalWinPays || 0), // reimbursement amount $ replace double
        //TotAmount: parseFloat(totalReimbursement || 0),
        PriorityID: priorityID,
        ShippingCarrier: shippingCarrier || "",
        TrackingNo: trackingNumber || "",
        Notes: shippingNotes || "",
        Reason: "", // No reason for task-level
        // RebateAmount: 0,
        //WithWinMarginWithoutRebate: 0, // rx cost before cost share
        //WintoPharmAmt: 0 // win has to pay amount
        WithWinMarginWithoutRebate: parseFloat(pharmReimbwithRebate || 0),
        WintoPharmAmt: parseFloat(totalWinPays || 0)
      };
      
        // Log the task-level payload for debugging
        

      console.log("Saving task-level payload:", taskPayload);
      await savePrescription(taskPayload);


      if (firstTaskDetail?.ContractType?.trim() === 'Premier' ||
          contract === 'Moelis-Cigna-Premier Rx' ) {

     try {
  const getPremierAccum = await getPremierAccumulatorModels(contract);
  if (getPremierAccum?.AccumAccess !== 'Y'  ) return;

  // const rxValidator = await loadRXCostshareValidate(
  //   memberID,
  //   authNo,
  //   userId
  // );
  // const rxValidatorValue = rxValidator?.Validation;
  // console.log("RX Validator Value:", rxValidatorValue);
 // if (rxValidatorValue !== 'Y') return;

  const rebateFlag = await loadRebateValidationFlag(
    contract,
    memberID,
    pharmacyId,
    userId
  );
  const rebateFlagValue = rebateFlag?.Validation;
  console.log("Rebate Validation Flag Value:", rebateFlagValue);

  const costShareRebateData = await saveCostShareRebateData(
    pharmReimbwithRebate,
    pharmReimbWithoutRebate,
    rebateFlagValue,
    totalMemberPays,
    authNo,
    taskId,
    contract,
    userId,
    memberID,
    totalMenopurCostShare
  );

  if (costShareRebateData) {
    console.log("Cost Share Rebate Data saved successfully:", costShareRebateData);
  }

} catch (error) {
  console.error("Error in cost share rebate flow:", error);
  toast.error("Failed to save cost share rebate data");
  navigate('/error-page');
} }

    
  
      toast.success("Prescription submitted successfully!");
      const result = await unlockRXDetails (taskPayload.Contract, taskPayload.UserID, taskPayload.TaskID
        , taskPayload.PharmacyID);


        if (result.success) {
                    toast.success('Task unlocked successfully');
                    // navigate('/process-prescription');
                    setShowThankYou(true);
                  } else {
                    toast.error(result.message || 'Failed to unlock task');
                    navigate('/error-page');
                  }

    } catch ( err ) {
      console.error('Error confirming tracking info:', err);
      toast.error('Failed to confirm tracking info');
      navigate('/error-page');
    }

  }

  //handle Back Window

  const handleBack = () => {
    try {
              setIsBackWindowOpen(true);
            } catch (err) {
              console.error('Unlock error:', err);
                toast.error('An error occurred while unlocking');
              }
  };

  const handleBackConfirm = async () => {
    try{
      setIsBackWindowOpen(false);
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user?.userId;
      const pharmacyId = user?.pharmacyId;
      if(!userId || !pharmacyId || !taskId || !contract) {
        toast.error('Missing required data for unlocking.');
        return;
      }

      await editOrderDetails({
        rxData: { TaskDetail: rxData },
        gridRows: clearedRows,
        userId,
        taskId,
        contract,
        shippingCarrier,
        trackingNumber,
        DispQty: 0,
        CancelQty: 0,
      });

      const result = await unlockRXDetails(contract, userId, taskId, pharmacyId);
      if (result.success) {
        toast.success('Task unlocked successfully');
        navigate('/process-prescription');
      } else {
        toast.error(result?.Message || 'Failed to unlock task');
      }

    }catch (err) {
      console.error('Unlock error:', err);
      toast.error('An error occurred while unlocking');
    }
  }

  //handle Cancel Order
  const handleCancelOrder = () => {
    try {
      setIsCancelOrderOpen(true);

    }catch (err) {
      console.error('Error opening cancel order modal:', err);
      toast.error('An error occurred while opening cancel order modal');
    }
  }

  const handleCancelConfirm = async () => {

    try {
      setIsCancelOrderOpen(false);
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user?.userId;
      const pharmacyId = user?.pharmacyId;
      if (!userId || !pharmacyId || !taskId || !contract) {
        toast.error('Missing required data for cancellation.');
        return;
      }
      const result = await cancelEntireOrder(taskId, contract, cancelReason, userId); // 👈 pass cancelReason
    if (result) {
      toast.success('Order cancelled successfully');
      navigate('/process-prescription');
    } else {
      toast.error(result?.Message || 'Failed to cancel order');
    }


    } catch (err) {
      console.error('Error confirming cancel order:', err);
      toast.error('An error occurred while confirming cancel order');
    }
  }

 //toatal reimbursement amount
  const totalReimbursement = gridRows.reduce((sum, row) => {
      return sum + parseFloat(row.ReimbursementAmountDisplay || 0);
    }, 0);

  const totalValueForDeduction = gridRows.reduce((sum, row) => {
      return sum + parseFloat(row.ReimbursementAmountValue || 0);
  }, 0 );

  // Total reimbursement for mainGridRows
const totalReimbursementMainGrid = mainGridRows.reduce(
  (sum, row) => sum + parseFloat(row.ReimbursementAmountDisplay || 0),
  0
);

// Total reimbursement for menopurGridRows
const totalReimbursementMenopurGrid = menopurGridRows.reduce(
  (sum, row) => sum + parseFloat(row.ReimbursementAmountDisplay || 0),
  0
);

  useEffect(() => {
  const safeTotalReimbursement = isNaN(totalReimbursement) ? 0 : totalReimbursement;
  const safeTotalValueForDeduction = isNaN(totalValueForDeduction) ? 0 : totalValueForDeduction;
  setPharmReimbWithoutReabtae(safeTotalReimbursement.toFixed(2));
  setPharmReimbwithRebate(safeTotalValueForDeduction.toFixed(2));
  console.log("totalValueForDeduction:", totalValueForDeduction, typeof totalValueForDeduction);
  console.log("values from pharmReimbWithoutReabtae:", safeTotalReimbursement, "pharmReimbwithRebate:", safeTotalValueForDeduction);
}, [totalReimbursement, totalValueForDeduction]);

if (!rxData) {
  return (
    <>
      <MenuBar />
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress sx={{ color: '#ec008c' }} />
        <span style={{ marginTop: '16px', color: '#ec008c', fontSize: '16px', fontWeight: 500 }}>
          Your request is being processed...
        </span>
      </Box>
    </>
  );
}

if (error) {
  navigate('/error-page');
  return null;
}

 

   // summary row for reimbursement amount

   let summaryRow = [];
   let summaryRowMainGrid = [];
   let summaryRowMenopurGrid = [];  

   if ((rxData[0]?.ContractType?.trim() === 'Premier' ||
    contract === 'Moelis-Cigna-Premier Rx'
  )&& memberConcernFlag === true) {
    summaryRowMainGrid = {
  id: 'summary-row-main',
  isSummary: true,
  ReimbursementAmount: totalReimbursementMainGrid.toFixed(2),
  ReimbursementAmountDisplay: totalReimbursementMainGrid.toFixed(2),
};

summaryRowMenopurGrid = {
  id: 'summary-row-menopur',
  isSummary: true,
  ReimbursementAmount: totalReimbursementMenopurGrid.toFixed(2),
  ReimbursementAmountDisplay: totalReimbursementMenopurGrid.toFixed(2),
};
   }
else {
if (
  contract === 'Chewy-Aetna-Premier' ||
  rxData[0]?.ContractType?.trim() === 'Premier' ||
  contract === 'Moelis-Cigna-Premier Rx' ||
  contract === 'WINFertilityRx' ||
  contract === 'WINFertility DTC'
) {
  const isWinFertility = contract === 'WINFertilityRx' || contract === 'WINFertility DTC';
  summaryRow = {
    id: 'summary-row',      // must be a unique ID
    isSummary: true,        // custom flag to identify this row
    ReimbursementAmount: totalReimbursement.toFixed(2), // this will hold copay total
    ReimbursementAmountDisplay: totalReimbursement.toFixed(2), // optional: to keep UI logic consistent
    ['Reimbursement Amount']: isWinFertility ? totalAmount : totalReimbursement.toFixed(2),
  };
} else if (contract === 'HMO Illinois' || contract === 'CIGNA') {
  summaryRow = {
    id: 'summary-row',      // must be a unique ID
    isSummary: true,        // custom flag to identify this row
    ReimbursementAmount: totalAmount, // this will hold copay total
    ReimbursementAmountDisplay: totalAmount, // optional: to keep UI logic consistent
    ['Reimbursement Amount']: totalAmount
  };
}

console.log("Summary Row:", summaryRow);
}

 //const totalValueForChewy = summaryRow.ReimbursementAmountDisplay || 0;

 

      // appending value to gridRows

     // const rowsWithSummary = [...gridRows, summaryRow];

     let rowsWithSummary = [];
     let mainRowsWithSummary = [];
      let menopurRowsWithSummary = [];
     
     if (rxData[0]?.ContractType === 'Premier' || contract === 'Moelis-Cigna-Premier Rx' 
       || contract === 'HMO Illinois' || contract === "CIGNA" || contract === "WINFertilityRx" || contract === 'WINFertility DTC') {
       rowsWithSummary = [...gridRows, summaryRow];
     } else {
       rowsWithSummary = gridRows;
     }

      console.log("Grid Rows with Summary:", rowsWithSummary);

      if ( (rxData[0]?.ContractType === 'Premier' 
      || contract === 'Moelis-Cigna-Premier Rx'
      ) && memberConcernFlag === true) {
      mainRowsWithSummary = [...mainGridRows, summaryRowMainGrid];
      menopurRowsWithSummary = [...menopurGridRows, summaryRowMenopurGrid];

      console.log("Main Grid Rows with Summary:", mainRowsWithSummary);
      console.log("Menopur Grid Rows with Summary:", menopurRowsWithSummary);
      }

    



      // extract Document Array
    const document = rxData?.Documents || [];

    const documentArray = document.map((doc, index) => ({

      id: index,
      documentList: doc.Path,
      bytes: doc.PDFDocument,
    })
  
  )

  const documentArraylength = documentArray.length;

  console.log("Document Array:", {documentArray, documentArraylength});

  // for checking Shipping carrier and tracking number
   console.log("Shipping Carrier:", shippingCarrier, "Tracking Number:", trackingNumber);

   console.log("Contract Type: => ", rxData[0]?.ContractType, "Contract:", contract);


   let widthForDrugName = 190;

   if (rxData[0]?.ContractType !== 'Premier' && contract !== 'Moelis-Cigna-Premier Rx' &&
        contract !== 'WINFertilityRx' && contract !== 'WINFertility DTC' && contract !== 'HMO Illinois' && contract !== 'CIGNA' ) {
      widthForDrugName = 260; // Adjust width for non-Premier contracts
        }

    console.log("Width for Drug Name:", widthForDrugName);


 

  let columns = [
    { field: 'MedStartDate', headerName: 'Med Start Date', width: 100, headerClassName: 'pink-header', sortable: false,},
{ 
  field: 'OR', 
  headerName: 'O/R', 
  width: 40, 
  renderCell: (params) => params.row.isSummary ? null : 'O', 
  headerClassName: 'pink-header' , sortable: false,
},    {
      field: 'NDC',
      headerName: 'NDC',
      flex: 1.5,sortable: false,
      renderCell: (params) => {
        const row = params.row;
        const rowDrugName = row.DrugName || '';
        let drugNameFlag = false;
        for (const item of rxData?.DrugInfos || []) {
          if (item.DrugName === rowDrugName) {
            drugNameFlag = true;
            break;
          }
        }
      
        if (row.DropDown === "Yes" && row.GPICode && drugNameFlag) {
          const gpiMatches = rxData.DrugInfos.filter(d => d.GPICode === row.GPICode);

           

        const defaultValue =
  row.NDC && row.PRP !== undefined
    ? `${row.NDC}|${parseFloat(row.PRP).toFixed(2)}`
    : gpiMatches.length > 0
      ? `${gpiMatches[0].NDC}|${parseFloat(gpiMatches[0].PRP).toFixed(2)}`
      : '';
      
          return (

<FormControl
  size="small"
  sx={{
    minWidth: '90%',
    background: '#fff',
    borderRadius: '10px',
    height: '60%',
    margin: '9px auto',
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      height: '100%',
      width: '100%',
      paddingRight: '8px',
      border: '1px solid rgb(236, 151, 202)',
      fontFamily: 'Segoe UI',
      fontSize: '10px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      '&.Mui-focused': {
        border: '1px solid #ec008c',
        boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
      },
      '&:hover': {
        border: '1px solid #ec008c',
      }
    },
    '& .MuiSelect-select': {
      padding: '8px 14px',
    },
    '& fieldset': {
      border: 'none'
    }
  }}
>
  <Select
    value={defaultValue}
    onChange={(e) => {
      const [selectedNDC, selectedPRP] = e.target.value.split('|');
      const selectedDrug = rxData.DrugInfos.find(
        d => d.NDC === selectedNDC && d.PRP === selectedPRP && d.GPICode === params.row.GPICode
      );
      if (!selectedDrug) return;
      const updatedRows = gridRows.map(item => {
        if (item.id === params.id) {
          const newPRP = parseFloat(selectedDrug.PRP || 0);
          const dispQty = parseFloat(item.DispQty || 0);
          const appQty = parseFloat(item.AppQty || 0);
          return {
            ...item,
            NDC: selectedNDC,
            PRP: newPRP,
            DrugName: selectedDrug.DrugName,
            GPIName: selectedDrug.GPIName,
            Effdt: selectedDrug.Effdt ? new Date(selectedDrug.Effdt).toLocaleDateString() : '—',
            ReimbursementAmount: dispQty ? (dispQty * newPRP).toFixed(2) : '',
            CancelQty: dispQty ? appQty - dispQty : '',
            ['Unit Price']: newPRP.toFixed(2),
          };
        }
        return item;
      });
      setGridRows(updatedRows);
      const newTotal = updatedRows.reduce((sum, row) => sum + parseFloat(row.Amount || 0), 0).toFixed(2);
      setTotalAmount(newTotal);
      setTotalWinPays(newTotal);
    }}
    displayEmpty
    inputProps={{ 'aria-label': 'Select NDC/PRP' }}
    sx={{
      fontFamily: 'Segoe UI',
      fontSize: '14px',
      borderRadius: '20px',
      background: '#fff'
    }}
  >
    {gpiMatches.map((drug, idx) => (
      // <MenuItem key={`${drug.NDC}-${drug.PRP}-${idx}`} value={`${drug.NDC}|${drug.PRP}`}>
      //   {`${drug.NDC} ($${parseFloat(drug.PRP).toFixed(2)})`}
      // </MenuItem>
      <MenuItem
  key={`${drug.NDC}-${drug.PRP}-${idx}`}
  value={`${drug.NDC}|${parseFloat(drug.PRP).toFixed(2)}`}
>
  {drug.NDC}
</MenuItem>
    ))}
  </Select>
</FormControl>
              
          );
        }
      
        return <span>{row.NDC}</span>;
      }
      ,
      headerClassName: 'pink-header'
    }
    ,
    { field: 'DrugName', headerName: 'Drug Name',flex:1.5, headerClassName: 'pink-header' , sortable: false,
    //   renderCell: (params) => (
    // <div
    //   style={{
    //     whiteSpace: 'normal',
    //     wordBreak: 'break-word',
    //     overflowWrap: 'break-word',
    //     lineHeight: 1.3,
    //     padding: '10px 2px',
    //     width: '100%',
    //   }}
    // >
    //   {params.value}
    // </div>)
    renderCell: (params) => (
      <div
        style={{
        display: 'flex',
        alignItems: 'center',   // vertical center
        justifyContent: 'left', // horizontal center
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        textAlign: 'left',
        padding: '2px 4px', // keep small padding
        width: '100%',
        height: '100%',     // ensures full cell height for vertical centering
      }}
      >
        {params.value}
      </div>
    )
    },
    { field: 'GPIName', headerName: 'GPI Name', flex:1.5, headerClassName: 'pink-header' , sortable: false, 
      renderCell: (params) => (
      <div
        style={{
        display: 'flex',
        alignItems: 'center',   // vertical center
        justifyContent: 'left', // horizontal center
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        textAlign: 'left',
        padding: '2px 4px', // keep small padding
        width: '100%',
        height: '100%',     // ensures full cell height for vertical centering
      }}
      >
        {params.value}
      </div>
    )
    },
    { field: 'AppQty', headerName: 'App Qty', flex:.7, headerClassName: 'pink-header' , sortable: false,
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
    },
    { field: 'Units', headerName: 'Units',flex:.8, headerClassName: 'pink-header' , sortable: false,},

    { field: 'DispQty',headerName: 'Disp Qty',flex:.7, sortable: false,
      style: {
        border: '1px solid #ec008c',
        borderRadius: '4px',
        height: '70%',
        width: '80%',
        outline: 'none',
      },
      renderCell: (params) => {
        if (params.row.isSummary) return null;
        if ( contract === "WINFertilityRx" || contract === "WINFertility DTC" ) {
              return <input type="number" value={params.row.DispQty || ''} readOnly  style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '50%',
            border: '1px solid #ec008c',
            borderRadius: '10px',
            height: '50%',
            outline: 'none',
            padding: '4px 8px',
            fontSize: '14px',
            fontFamily: 'Segoe UI',
            margin: '7px auto'
          }} />;
        }

        if (((rxData?.ContractType && rxData?.ContractType?.trim() === 'Premier') && memberConcernFlag) || 
      (rxData[0]?.ContractType && rxData[0]?.ContractType?.trim() === 'Premier' && memberConcernFlag) ||
      (contract === "Moelis-Cigna-Premier Rx" && memberConcernFlag)) {
          
        return (
       <input
  type="number"
  min={0}
  value={params.row.DispQty === 0 ? 0 : params.row.DispQty || ''}
   className="no-spinner"
  onChange={(e) => {
    const val = parseFloat(e.target.value);
    if (val < 0 || val > 1000) {  // sanity check
      toast.error("Invalid Disp Qty entered");
      return;
    }
     if (params.row.DrugName?.toUpperCase().includes('MENOPUR')) {
    handleDispQtyChangeMenopurGrid(val, params.row.id);
  } else {
    handleDispQtyChangeMainGrid(val, params.row.id);
  }
  }}
  style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '50%',
            border: '1px solid #ec008c',
            borderRadius: '10px',
            height: '50%',
            outline: 'none',
            padding: '4px 8px',
            fontSize: '14px',
            fontFamily: 'Segoe UI',
            margin: '7px auto'
          }}
/>

)}

        if (((rxData?.ContractType && rxData?.ContractType?.trim() === 'Premier') && !memberConcernFlag) || 
      (rxData[0]?.ContractType && rxData[0]?.ContractType?.trim() === 'Premier' && !memberConcernFlag) ||
      (contract === "Moelis-Cigna-Premier Rx" && !memberConcernFlag)) {
          
        return (
       <input
  type="number"
  className="no-spinner"
  min={0}
    value={params.row.DispQty === 0 ? 0 : params.row.DispQty || ''}
  onChange={(e) => {
    const val = parseFloat(e.target.value);
    if (val < 0 || val > 1000) {  // sanity check
      toast.error("Invalid Disp Qty entered");
      return;
    }
    handleDispQtyChangePremier(val, params.row.id);
  }}
  style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40%',
            border: '1px solid #ec008c',
            borderRadius: '10px',
            height: '50%',
            outline: 'none',
            padding: '4px 8px',
            fontSize: '14px',
            fontFamily: 'Segoe UI',
            margin: '7px auto'
          }}
/>

)}else if (contract === 'HMO Illinois' || contract === 'CIGNA') {
  return (<input
  type="number"
  className="no-spinner"
  min={0}
    value={params.row.DispQty === 0 ? 0 : params.row.DispQty || ''}
  onChange={(e) => {
    const val = parseFloat(e.target.value);
    if (val < 0 || val > 1000) {  // sanity check
      toast.error("Invalid Disp Qty entered");
      return;
    }
    handleDispQtyChangeHMOI(val, params.row.id);
  }}
  style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40%',
            border: '1px solid #ec008c',
            borderRadius: '10px',
            height: '50%',
            outline: 'none',
            padding: '4px 8px',
            fontSize: '14px',
            fontFamily: 'Segoe UI',
            margin: '7px auto'
          }}
/>
)
} else {
   return (<input
  type="number"
  className="no-spinner"
  min={0}
   value={params.row.DispQty === 0 ? 0 : params.row.DispQty || ''}
  onChange={(e) => {
    const val = parseFloat(e.target.value);
    if (val < 0 || val > 1000) {  // sanity check
      toast.error("Invalid Disp Qty entered");
      return;
    }
    handleDispQtyChangeNonPremier(val, params.row.id);
  }}
  style={{
           display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40%',
            border: '1px solid #ec008c',
            borderRadius: '10px',
            height: '50%',
            outline: 'none',
            padding: '4px 8px',
            fontSize: '14px',
            fontFamily: 'Segoe UI',
            margin: '7px auto'
          }}
/>
)
}
},
      headerClassName: 'pink-header'
    },
    {
      field: 'CancelQty',
      headerName: 'Cancel Qty',
      width: 80, sortable: false,
      renderCell: (params) => {
        
        if (params.row.isSummary) return null;
        return (
      
        <input type="text" value={params.row.CancelQty} readOnly style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '50%',
            border: '1px solid #ec008c',
            borderRadius: '10px',
            height: '50%',
            outline: 'none',
            padding: '4px 8px',
            fontSize: '14px',
            fontFamily: 'Segoe UI',
            margin: '7px auto'
          }} />
      )},
      headerClassName: 'pink-header'
    },
    {
  field: 'Reason',
  headerName: 'Reason',
  width: 180,
  sortable: false,
  renderCell: (params) => {
    if (params.row.isSummary) return null;

    // Member Concern: update correct grid
    if (
      ((rxData?.ContractType && rxData?.ContractType?.trim() === 'Premier') && memberConcernFlag) ||
      (rxData[0]?.ContractType && rxData[0]?.ContractType?.trim() === 'Premier' && memberConcernFlag) ||
      (contract === "Moelis-Cigna-Premier Rx" && memberConcernFlag)
    ) {
      return (
        <FormControl
          size="small"
          sx={{
            minWidth: '90%',
            background: '#fff',
            borderRadius: '10px',
            height: '60%',
            margin: '9px auto',
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              height: '100%',
              width: '100%',
              paddingRight: '8px',
              border: '1px solid rgb(236, 151, 202)',
              fontFamily: 'Segoe UI',
              fontSize: '10px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              '&.Mui-focused': {
                border: '1px solid #ec008c',
                boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
              },
              '&:hover': {
                border: '1px solid #ec008c',
              }
            },
            '& .MuiSelect-select': {
              padding: '8px 14px',
            },
            '& fieldset': {
              border: 'none'
            }
          }}
        >
          <Select
            value={params.row.Reason || ''}
            onChange={(e) => {
              if (params.row.DrugName?.toUpperCase().includes('MENOPUR')) {
                // Update menopur grid

                const updatedRows = menopurGridRows.map(row =>
                  row.id === params.row.id ? { ...row, Reason: e.target.value } : row
                );
                
                const updategridRows = [...gridRows];

                for (let i = 0; i < updategridRows.length; i++) {
                  if (updategridRows[i].DrugName?.toUpperCase().includes('MENOPUR')) {
                    updategridRows[i].Reason = e.target.value;
                    break; // Exit loop after updating the matching row
                  }
                }

                setGridRows(updategridRows);
                setMenopurGridRows(updatedRows);
              } else {
                // Update main grid
                const updatedRows = mainGridRows.map(row =>
                  row.id === params.row.id ? { ...row, Reason: e.target.value } : row
                );
                const drugName = params.row.DrugName;
                const updategridRows = [...gridRows];
                for (let i = 0; i < updategridRows.length; i++) {
                  if (updategridRows[i].DrugName === drugName) {
                    updategridRows[i].Reason = e.target.value;
                    break; // Exit loop after updating the matching row
                  }
                }
                setGridRows(updategridRows);
                setMainGridRows(updatedRows);
              }
            }}
            displayEmpty
            inputProps={{ 'aria-label': 'Select reason' }}
            sx={{
              fontFamily: 'Segoe UI',
              fontSize: '14px',
              borderRadius: '20px',
              background: '#fff'
            }}
          >
            <MenuItem value="">--Select--</MenuItem>
            <MenuItem value="No Drug">No Drug</MenuItem>
            <MenuItem value="Patient Request">Patient Request</MenuItem>
            <MenuItem value="Inappropriate Request">Inappropriate Request</MenuItem>
            <MenuItem value="Exceeds Plan Limits">Exceeds Plan Limits</MenuItem>
            <MenuItem value="Switched to Generic">Switched to Generic</MenuItem>
          </Select>
        </FormControl>
      );
    }

    // Default: update gridRows
    return (
      <FormControl
        size="small"
        sx={{
          minWidth: '90%',
          background: '#fff',
          borderRadius: '10px',
          height: '60%',
          margin: '9px auto',
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            height: '100%',
            width: '100%',
            paddingRight: '8px',
            border: '1px solid rgb(236, 151, 202)',
            fontFamily: 'Segoe UI',
            fontSize: '10px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            '&.Mui-focused': {
              border: '1px solid #ec008c',
              boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
            },
            '&:hover': {
              border: '1px solid #ec008c',
            }
          },
          '& .MuiSelect-select': {
            padding: '8px 14px',
          },
          '& fieldset': {
            border: 'none'
          }
        }}
      >
        <Select
          value={params.row.Reason || ''}
          onChange={(e) => {
            const updatedRows = gridRows.map(row =>
              row.id === params.row.id ? { ...row, Reason: e.target.value } : row
            );
            setGridRows(updatedRows);
          }}
          displayEmpty
          inputProps={{ 'aria-label': 'Select reason' }}
          sx={{
            fontFamily: 'Segoe UI',
            fontSize: '14px',
            borderRadius: '20px',
            background: '#fff'
          }}
        >
          <MenuItem value="">--Select--</MenuItem>
          <MenuItem value="No Drug">No Drug</MenuItem>
          <MenuItem value="Patient Request">Patient Request</MenuItem>
          <MenuItem value="Inappropriate Request">Inappropriate Request</MenuItem>
          <MenuItem value="Exceeds Plan Limits">Exceeds Plan Limits</MenuItem>
          <MenuItem value="Switched to Generic">Switched to Generic</MenuItem>
        </Select>
      </FormControl>
    );
  },
  headerClassName: 'pink-header'
}
    ,];
    if (
      
      contract === 'HMO Illinois' || contract === 'CIGNA'
    ) {
      columns.push({
        field: 'ReimbursmentAmount',
        headerName: 'Reimbursment Amount',
        width: 141,  sortable: false,
        headerClassName: 'pink-header',
        renderCell: (params) => {
          if (params.row.isSummary) {
    return <strong>Total: ${params.row.ReimbursementAmountDisplay || '0.00'}</strong>;
  }
  
         return <span>{params.row.ReimbursementAmount ? parseFloat(params.row.ReimbursementAmount).toFixed(2) : '0.00'}</span>
        }
      });
    }else if ((rxData?.ContractType && rxData?.ContractType?.trim() === 'Premier') || 
    (rxData[0]?.ContractType && rxData[0]?.ContractType?.trim() === 'Premier') ||
    (contract === "Moelis-Cigna-Premier Rx" )) {
        //console.log(rxData?.ContractType?.trim());
        columns.push(
          {
        field: 'ReimbursementAmount',
        headerName: 'Reimbursement Amount',
        width: 141,  sortable: false,
        headerClassName: 'pink-header',
        renderCell: (params) => {
  if (params.row.isSummary) {
    return <strong>Total: ${params.row.ReimbursementAmountDisplay || '0.00'}</strong>;
  }
  return <span>${params.row.ReimbursementAmountDisplay || '0.00'}</span>;
}

        
      });

      }else if (contract === 'WINFertilityRx' || contract === 'WINFertility DTC') {
  columns.push({
    field: 'Reimbursment Amount',
    headerName: 'Reimbursment Amount',
    width: 141,  sortable: false,
    headerClassName: 'pink-header',
    renderCell: (params) => {
      if (params.row.isSummary) {
        return <strong>Total: ${params.row['Reimbursement Amount'] || '0.00'}</strong>;
      }
      return <span>{params.row?.['Reimbursment Amount'] ? parseFloat(params.row['Reimbursment Amount']).toFixed(2) : '0.00'}</span>;
    }
  });
}
  
const winCardCol = {
  field: 'WinCard',
  headerName: 'WinCard',
  width: 200,
  sortable: false,
  headerClassName: 'pink-header',
  renderCell: (params) => {
    if (!params.row.DrugName?.toUpperCase().includes('MENOPUR') || params.row.isSummary) return null;

    if (showMemberWinCard){
    return (
      <button
        style={{
          padding: '4px 12px',
          borderRadius: '8px',
          background: '#ec008c',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          fontSize: '13px'
        }}
        onClick={ async () => {
          console.log("WinCard button triggered:");
          const info = {
            PresID: params.row.PresID,
            MemberID: params.row.MemberID,
            external_requestor_id: requestId,
            // ...add other required fields if needed
          };
          const winCardLink = await getWinCardUrl(info);
          if (winCardLink) {
          // Replace the empty external_requestor_id in the URL with info.external_requestor_id
          const updatedLink = winCardLink.replace(
            /external_requestor_id=([^&]*)/,
            `external_requestor_id=${encodeURIComponent(info.external_requestor_id)}`
          );
          window.open(updatedLink, '_blank');
        } else {
          toast.error("Win Card link not available.");
        }
        }}
      >
        View WinCard
      </button>
    );
  } else if (!showMemberWinCard) {
    return (
      <span style={{ color: 'gray',  fontSize: '12px', 
        wordBreak: 'break-word', textAlign: 'center'
       }}>
        Call member to get card details
      </span>
    );

  }
  }
}
//  Menopur grid columns: start from main and then add WINCard when that scenario applies
const showWinCard =
  (memberConcernFlag === true ) &&
  (rxData?.ContractType?.trim() === 'Premier' || rxData?.[0]?.ContractType?.trim() === 'Premier'
  || contract === 'Moelis-Cigna-Premier Rx');

const columnsMenopur = showWinCard ? [...columns, winCardCol] : columns;
 
    console.log("This is the rebate flag:", rebateValidationFlag);



    // FUNCTION FOR HANDLING DRUG COUNT

    const calculateDrugCount = (prescriptions) => {
  let count = 0;

  prescriptions.forEach((item) => {
    const drugName = item.DrugName?.toUpperCase() || '';
    const appQty = parseFloat(item.AppQty || 0);
    const amount = parseFloat(item['Reimbursment Amount'] || 0);

    const isExcludedDrug =
      drugName === 'OTHER SUPPLIES' ||
      drugName === 'OTHER DRUGS';

    const isCommonForm =
      drugName.includes('SYRINGE') ||
      drugName.includes('NEEDLE') ||
      drugName.includes('PEN') ||
      drugName.includes('VIAL') ||
      drugName.includes('TAB') ||
      drugName.includes('SOFTGELS');

    if (
      appQty > 0 &&
      !isExcludedDrug &&
      (!isCommonForm || amount !== 0)
    ) {
      count++;
    }
  });
  console.log("This is the Calculated Drug Count:", count);
  return count;
};


    
  return (
    <>
    {!showSummary &&(
    <div>
      <Toaster position="top-right"  />

      <MenuBar onNavigateAttempt={() => setIsBackWindowOpen(true)} />

      <div className='top-page-option'>
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', position: 'relative', top: '2px' }}>
          <a 
            href="#/process-prescription" 
            style={{
              textDecoration: 'none',
              color: '#ec088c',
              display: 'inline-flex',
              alignItems: 'center'
            }}
            onClick={async () => {
              try {
                const user = JSON.parse(localStorage.getItem('user'));
                const userId = user?.userId;
                const pharmacyId = user?.pharmacyId;
                if (!userId || !pharmacyId || !taskId || !contract) {
                  toast.error('Missing required data for unlocking.');
                  return;
                }
                const result = await unlockRXDetails(contract, userId, taskId, pharmacyId);

                if (result.success) {
                  toast.success('Task unlocked successfully');
                } else {
                  toast.error(result?.Message || 'Failed to unlock task');
                }
              } catch (err) {
                console.error('Unlock error:', err);
                toast.error('An error occurred while unlocking');
              }
            }}
          >
            <ChevronLeft color='#ec088c' size={18} />
            <span style={{ marginLeft: '2px' }}>Back</span>
          </a>
        </div>

        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <span>New Orders</span>
          <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
          <span>Process Prescription</span>
          <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }}/>
          <span>Open Orders</span>
        </div>

       
      </div>


       <div className="outer-box" style={{
          background: '#fff',
          padding: '0px',
          borderRadius: '10px',
          marginLeft: '100px',
          marginRight: '100px',
          textAlign: 'left', // force left alignment for all children
          alignItems: 'flex-start', // ensure children align left
          display: 'block' // remove any flex centering
        }}> 
        <div className="open-order-box" style={{fontFamily: 'segoe ui', textAlign: 'left', alignItems: 'flex-start', display: 'block' }}>

        <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', marginBottom: '-5px',marginLeft:'25px', fontSize: '18px' }}>Member Info</div>
<br style={{ display: 'none' }} />
<div className="details-grid" style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '18px 32px',
  borderRadius: '10px',
  padding: '18px 24px',
  marginBottom: '-30px',
  alignItems: 'start',
  fontSize: '14px',
  color: '#222',
  fontFamily: 'segoe ui',
  textAlign: 'left',
  justifyItems: 'start',
  width: 'fit-content',
  marginLeft: 0
}}>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '140px', display: 'inline-block', flexShrink: 0 }}>Member ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.MemberID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '140px', display: 'inline-block', flexShrink: 0 }}>First Name :</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{firstName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '140px', display: 'inline-block', flexShrink: 0 }}>Last Name :</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{lastName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>DOB:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-80px', wordBreak: 'break-all', flex: 1 }}>{new Date(rxData[0]?.DOB).toLocaleDateString()}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '175px', display: 'inline-block', flexShrink: 0 }}>Member Phone:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.CellPhone}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Email ID:</strong>
    {rxData[0]?.EmailID && rxData[0]?.EmailID.length > 30 ? (
      <div style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', whiteSpace: 'pre-line', flex: 1 }}>{rxData[0]?.EmailID}</div>
    ) : (
      <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.EmailID}</span>
    )}
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>Relationship:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.RelationShip || 'N/A'}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '16x', minWidth: '145px', display: 'inline-block', flexShrink: 0 }}>Certified for:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{rxData[0]?.CertifiedFor}</span>
  </div>
</div><br/>

<div style={{ margin: '20px 0', width: '100%', paddingLeft: '20px' }}>
  <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '14px', tableLayout: 'fixed', fontFamily: 'segoe ui' }}>
    <colgroup>
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '2px', color: '#ec008c', fontWeight: 'bold', fontFamily: 'segoe ui', textAlign: 'left', fontSize: '18px' }}>Provider Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontFamily: 'segoe ui', textAlign: 'left',  fontSize: '18px' }}>Authorization Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontFamily: 'segoe ui', textAlign: 'left',  fontSize: '18px' }}>Attachments</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '2px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Name:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.SerProName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.Telephone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.Fax}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>WIN Auth #:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.FormattedAuthNo}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Auth Duration:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.["Auth Duration"]}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Contract:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{contract}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          {documentArray.length > 0 && (
  <div className="attachment-box" style={{ flex: "0 1 300px", textAlign: 'left', paddingTop: '-20px', fontFamily: 'segoe ui', marginTop: '-14px' }}>
    {documentArray.map((doc, index) => {
      const fileUrl = doc.documentList.replaceAll('\\', '/').replaceAll('\\\\', '/');
      const fileName = fileUrl.split('/').pop();
      // const downloadUrl = attachmentUrls[index]; // Not needed for handleFileDisplay
      return (
        <button
          key={doc.id}
          type="button"
          className="attachment-link"
          style={{
            color: 'blue',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            fontFamily: 'segoe ui',
            fontSize: '14px',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          onClick={() => handleFileDisplay(doc.documentList, doc.bytes)}
        >
          <strong style={{ fontSize: '15px', fontFamily: 'segoe ui', marginRight: '4px', textDecoration: 'none' }}>{`Prescription ${index + 1}:`}</strong>
          <span style={{ fontSize: '14px', fontFamily: 'segoe ui', textDecoration: 'underline' }}>{fileName}</span>
        </button>
      );
    })}
  </div>
)}
        </td>
      </tr>
    </tbody>
  </table>
  {/* New 2-column table below the existing table, same design */}

 <table style={{ marginTop:'30px',borderCollapse: 'collapse', width: '100%', fontSize: '14px', tableLayout: 'fixed', fontFamily: 'segoe ui',padding: '0 5px' }}>
    <colgroup>
      <col style={{ width: '33.3%' }} />
      <col style={{ width: '66.7%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '2px', color: '#ec008c', fontWeight: 'bold', fontSize: '14px', fontFamily: 'segoe ui', textAlign: 'left',  fontSize: '18px' }}>Task Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '14px', fontFamily: 'segoe ui', textAlign: 'left',  fontSize: '18px' }}>Task Notes</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui' }}>
          
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Assigned by:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.AssignedBy}</span>
          </div>
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Group ID:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.GroupID}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Priority:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.PriorityStatus}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Received:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.ReceivedDate}</span>
          </div>
		   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Med Start Date:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData[0]?.SchStartDate}</span>
          </div>
         </td>
      <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "40px",
        maxWidth: "80%",
      }}
    >
      <div
        className="notes-box"
        style={{
          flex: "1 1 300px",
          position: 'relative',
          padding: '4px',
          transition: 'box-shadow 0.2s',
          outline: 'none',
        }}
        onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        tabIndex={0}
      >
        <textarea
  className="notes-textarea"
  value={notes}
  onChange={(e) => setNotes(e.target.value)}
  style={{
    width: "95%",
    minHeight: "100px",
    padding: "12px",
    fontSize: "13px",
    border: '1px solid rgba(236, 152, 202)',
    borderRadius: '25px',
    resize: "vertical",
    background: 'white',
    outline: 'none',
    color: notesBoxActive ? '#ec008c' : 'black',
    transition: 'color 0.2s',
  }}
  onFocus={(e) => {
    e.target.style.border = '1px solid #ec008c';
    e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
  }}
  onBlur={(e) => {
    e.target.style.border = '1px solid rgba(236, 152, 202)';
    e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
  }}
/>
      </div>
    </div>
        </td>
      </tr>
    </tbody>
  </table>

</div>

{cignaContract.includes(contract) && (
  <div style={{ margin: '5px', width: '100%', paddingLeft: '20px', fontFamily: 'segoe ui' }}>
    
    <span style={{ marginRight: '20px' }}>
  {cignaContract.includes(contract) && contract === 'CIGNA'
    ? <strong><label>CIGNA Medical Auth# : </label></strong>
    : <strong><label>Medical Auth# : </label></strong>
  }

       <input
            type="text"
            name="medicalAuth"
            autoComplete='off'
            value={medicalAuth}
            onChange={(e) => setMedicalAuth(e.target.value)}
            style={{
              width: '10%',
              height: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '10px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px', 
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
    </span>
    { (cignaContract.includes(contract) && contract !== 'CIGNA') && (
      <span>
      <strong><label >Cigna Rx Auth# : </label></strong>
       <input
            type="text"
            name="cignaRXAuth"
            autoComplete='off'
            value={cignaRXAuth}
            onChange={(e) => setCignaRXAuth(e.target.value)}
            style={{
              width: '10%',
              height: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '10px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px', 
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
    </span>)}
  </div>
)}
        
                </div>


                {(contract === "HMO Illinois" ||  (rxData?.ContractType && rxData.ContractType.trim() !== '') || (  rxData[0]?.ContractType &&
  rxData[0]?.ContractType.trim() !== '') || (contract === "Moelis-Cigna-Premier Rx") || (contract === "WINFertilityRx") || 
(contract === 'WINFertility DTC')) && (
                    <div className="open-order-box" style={{ fontFamily: 'segoe ui' }}>
                      <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold',  fontSize: '18px' }}>Shipping Info</div><br/>
                      <table className='Shpping-Info-table' style={{ margin: '0 auto', width: '60%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
  <colgroup>
    <col style={{ width: '50%' }} />
    <col style={{ width: '50%' }} />
  </colgroup>
  <tbody>
    <tr>
      <td style={{ fontSize: '15px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec088c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData.ShippingInfos[0]?.Phone}</span>
        </div>  
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '130px', display: 'inline-block' }}>Shipping Carrier :&nbsp;</strong>
          
          <FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
  <InputLabel sx={{ fontFamily: 'segoe ui', marginBottom: '10px', background: '#fff', color: 'black', fontSize: '12px' }}>
    --Select--
  </InputLabel>
  <Select
    value={shippingCarrier}
            onChange={(e) => setShippingCarrier(e.target.value)}
    label="Select"
    sx={{
      fontFamily: 'segoe ui',
      fontSize: '12px',
      border: '1px solid rgba(236, 152, 202)',
      borderRadius: '10px',
      height: '30px',
      boxShadow: 'none',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
        boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
      },
    }}
  >
    <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
      --Select--
    </MenuItem>
    
      <MenuItem value="Fedex" sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
        FedEx
      </MenuItem>
      <MenuItem value="UPS" sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
        UPS
      </MenuItem>
      <MenuItem value="Others" sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#ec008c', color: 'white' } }}>
        Others
      </MenuItem>
    
  </Select>
</FormControl>
          
         
        </div>
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{rxData.ShippingInfos[0]?.Fax || '—'}</span>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>#Tracking :</strong>
          <input
            type="text"
            name="trackingID"
            autoComplete='off'
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            style={{
              width: '30%',
              height: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '10px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px', 
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
        </div>
        {/* Show tracking result below input */}
        
        {trackingResult && (
  <div
    style={{
      color: trackingResult.success ? 'green' : 'red',
      marginTop: '6px',
      marginLeft: '10px',
    }}
  >
    {trackingResult.success === false && (
  <div style={{ color: 'red',  textAlign: 'left' }}>
    We were unable to fetch tracking details at the moment.
    Please try again later.
  </div>
)}
    {trackingResult.success === true && !errorTrackingStatus ? (
  latestStatus === 'Delivered' ? (
    <>
      Success! <br />
      Your package was successfully {latestStatus} on {actualDeliveryDate}. <br />
    </>
  ) : (
     <>
      Success! <br />
      We have found your Shipment details. <br />
      Your package is Currently {latestStatus} and is scheduled for delivery on {actualDeliveryDate}. <br />
    </>
  )
) : null}
 
 {errorTrackingStatus &&
  <div style={{ color: 'red', textAlign: 'left' }}>
   We couldn't find any tracking information for the number provided.
    Please double check your tracking number and try again.
  </div>
 }
 
  </div>
)}

      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Address :</strong>
          <textarea value={rxData.ShippingInfos[0]?.Address || ''}
            readOnly
            style={{
              width: '80%',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px', 
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          ></textarea>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Notes :</strong>
          <textarea name="trackingID"
          onChange={(e) => setShippingNotes(e.target.value)}
          value={shippingNotes}
            style={{
              width: '500px',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
              outline: 'none',
            }} 
            onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
            placeholder='Please enter the Notes'></textarea>
        </div>
      </td>
    </tr>
  </tbody>
</table>

</div>
                )}


                <div className="sub-section-header" style={{ color: '#ec008c', fontWeight: 'bold', margin: '10px 14px',  fontSize: '18px', textAlign: 'left', padding: '10px' }}>Prescriptions</div>
                { contract === "HMO Illinois"  &&(
                <div className="sub-section-header" style={{ color: 'red', fontWeight: 'bold', margin: '10px 14px',  fontSize: '12px', textAlign: 'left', padding: '10px' }}>This order is for a WIN member where WIN will pay for the drugs directly. Bill WIN directly by submitting the tracking number for only those drugs where you are expecting payment from WIN. All other drugs should be marked as cancelled.</div>
                )}
                { contract === "Chewy-Aetna-Premier"  &&(
                <div className="sub-section-header" style={{ color: 'red', fontWeight: 'bold', margin: '10px 14px',  fontSize: '12px', textAlign: 'left', padding: '10px' }}>This order is for a WIN Premier member. Bill WIN directly by submitting the tracking number for only those drugs where you are expecting payment from WIN. All other drugs should be marked as cancelled. Remaining deductible and coinsurance within the overall cost of the approved Rx should be collected by the pharmacy at the time that the Rx is dispensed. WIN will be paying the remainder owed within the benefit lifetime max.</div>
                )}
                { (contract === "SchoolCare" || contract === "Gartner-Cigna" || contract === "Smith & Nephew" 
                // || contract === "Lurie Childrens Hospital-Aetna-Premier" 
                  
                 ) &&(
                <div className="sub-section-header" style={{ color: 'red', fontWeight: 'bold', margin: '10px 14px',  fontSize: '12px', textAlign: 'left', padding: '10px' }}>Members in this contract are under Cigna PBM. Please contact Cigna PBM if the necessary authorization number is missing.</div>
                )}

                <div style={{ height: 'auto', width: '100%' }}>
                    {(( rxData[0]?.ContractType === 'Premier' || 
                        contract === "Moelis-Cigna-Premier Rx" 
                     ) && memberConcernFlag === true 
                    )&& (
  <>
  { (mainGridRows.length > 0) &&(
    <DataGrid
      rows={mainRowsWithSummary}
      columns={columns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      hideFooter
      getRowClassName={(params) =>
        params.row.isSummary ? 'summary-row' : ''
      }
      sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', /* Optional: center the header text */
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
    />
        )}
    <DataGrid
      rows={menopurRowsWithSummary}
      columns={columnsMenopur}
      pageSize={5}
      rowsPerPageOptions={[5]}
      hideFooter
      getRowClassName={(params) =>
        params.row.isSummary ? 'summary-row' : ''
      }
      sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', /* Optional: center the header text */
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
    />
  </>
)}
                      { (memberConcernFlag === false &&(<DataGrid
                        rows={rowsWithSummary}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        hideFooter
                        getRowClassName={(params) =>
                        params.row.isSummary ? 'summary-row' : ''}
                        sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', /* Optional: center the header text */
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
                      />))}
  <div style={{
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: '10px',
  paddingRight: '20px',
  fontWeight: 'bold',
  fontSize: '14px'
}}>
  {(contract === 'HMO Illinois' || contract === "CIGNA" || contract === 'WINFertilityRx' || contract === 'WINFertility DTC') && (
    <div style={{ marginLeft: '20px', color: '#000' }}>
      Total Amount: ${totalWinPays}
    </div>
  )}

  {/* {(contract === 'Chewy-Aetna-Premier' ) && (
    <div style={{ marginLeft: '20px', color: '#000' }}>
      Total Amount: ${totalValueForChewy}
    </div>
  )} */}

  {(rxData?.ContractType?.trim() === 'Premier' || rxData[0]?.ContractType?.trim() === 'Premier'
   || contract === "Moelis-Cigna-Premier Rx" ) && (
    <div flex={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: '20px', color: '#000' }}>
      <div style={{ marginLeft: '20px', color: '#000', textAlign: 'right' }}>
        Member Cost Share: ${totalMemberPays}
      </div>
      <div style={{ marginLeft: '20px', color: '#000', textAlign: 'right' }}>
        WIN To Pharmacy: ${Math.max(0, totalWinPays)}
      </div>
      {(memberConcernFlag === true && menopurGridRows.some(row => parseFloat(row.DispQty) > 0)) && (
      <div style={{ marginLeft: '20px', color: '#000', textAlign: 'right' }}>
        Win Card Value: ${winCardAmount}
      </div>
    )}
      </div>
    
  )}
</div>
                
      </div>
        <div className="button-div" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px' }}>
            {(contract !== 'WINFertilityRx' && contract !== 'WINFertility DTC' ) && (
            <button className="button-open-order"
            onClick={handleCancelOrder}>Cancel Entire Order</button>)}
            <button
          onClick={handleBack}
            className="button-open-order"
          >
            Back
          </button>
            <button
            className="button-open-order"
          onClick={handleSubmit}
            >
              Submit
            </button>

          </div>
      </div>
    </div>
                    )}

                     {showSummary && (
                      <OrderSummary
                      flag = {'Process'}
                      rxData={rxData}
                      gridRows={gridRows}
                      menopurGridRows = {menopurGridRows}
                      maingridRows = {mainGridRows}
                      columns={columns}
                      totalAmount={totalAmount}
                      userId={ userId} // include both if needed
                      shippingCarrier={shippingCarrier}
                      trackingNumber={trackingNumber}
                      notes={notes} // or use any notes input
                      taskId={taskId}
                      pharmacyId={pharmacyId}
                      TotalCopay = {totalCopay}
                      TotalMenopurCostShare = {totalMenopurCostShare}
                      TotalMemberPays={totalMemberPays}
                      TotalWinPays = {totalWinPays}
                      RebateValidationFlag = {rebateValidationFlag}
                      CostPharmacyData={costPharmacyData}
                      PharmReimbWithoutRebate = {pharmReimbWithoutRebate}
                      PharmReimbWithRebate = {pharmReimbwithRebate}
                      Contract={contract}
                      totalWinCardAmount={winCardAmount}
                      
                      //onConfirm={handleModalConfirm}
                      onCancel={() => setShowSummary(false)}
                    />
                    )}

<TrackingModal
  open={showTrackingModal}
  onClose={() => setShowTrackingModal(false)}
  onConfirm={handleModalConfirm}
/>

{isBackWindowOpen && (
  <BackWindowModal
  open={isBackWindowOpen}
  onClose={() => setIsBackWindowOpen(false)}
  onConfirm={handleBackConfirm}
  />)}

  {isCancelOrderOpen && (
    <CancelOrderModal 
    open={isCancelOrderOpen}
  onClose={() => setIsCancelOrderOpen(false)}
  onConfirm={handleCancelConfirm}
  currentReason={cancelReason}
  onReasonChange={setCancelReason}
  disableConfirm={false}
    />)}

    <ThankYouModal open={showThankYou} />

</>                 
  );
};

export default OpenOrders;

